var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6AxTandemTridem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3095.24 803.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-195,.cls-196,.cls-197,.cls-198,.cls-199,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-210{stroke-width:0px;}.cls-2,.cls-206{fill:#414042;}.cls-3,.cls-6,.cls-7,.cls-84,.cls-211,.cls-189,.cls-190,.cls-192,.cls-202,.cls-203,.cls-206,.cls-208,.cls-209{mix-blend-mode:multiply;}.cls-3,.cls-178{fill:#f1f2f2;}.cls-4{fill:url(#New_Gradient_Swatch_4);}.cls-5{fill:url(#New_Gradient_Swatch_3);}.cls-6{fill:url(#linear-gradient-67);}.cls-7{fill:url(#linear-gradient-66);}.cls-8{fill:url(#New_Gradient_Swatch_3-3);}.cls-9{fill:url(#New_Gradient_Swatch_3-4);}.cls-10{fill:url(#New_Gradient_Swatch_3-9);}.cls-11{fill:url(#New_Gradient_Swatch_3-8);}.cls-12{fill:url(#New_Gradient_Swatch_3-7);}.cls-13{fill:url(#New_Gradient_Swatch_3-6);}.cls-14{fill:url(#New_Gradient_Swatch_3-2);}.cls-15{fill:url(#New_Gradient_Swatch_3-5);}.cls-16{fill:url(#New_Gradient_Swatch_4-3);}.cls-17{fill:url(#New_Gradient_Swatch_4-2);}.cls-18{fill:url(#New_Gradient_Swatch_4-6);}.cls-19{fill:url(#New_Gradient_Swatch_4-4);}.cls-20{fill:url(#New_Gradient_Swatch_4-5);}.cls-21{fill:#f7941d;}.cls-22{fill:url(#linear-gradient-120);}.cls-23{fill:url(#linear-gradient-125);}.cls-24{fill:url(#linear-gradient-124);}.cls-25{fill:url(#linear-gradient-126);}.cls-26{fill:url(#linear-gradient-138);}.cls-27{fill:url(#linear-gradient-139);}.cls-28{fill:url(#linear-gradient-134);}.cls-29{fill:url(#linear-gradient-131);}.cls-30{fill:url(#linear-gradient-136);}.cls-31{fill:url(#linear-gradient-132);}.cls-32{fill:url(#linear-gradient-135);}.cls-33{fill:url(#linear-gradient-130);}.cls-34{fill:url(#linear-gradient-133);}.cls-35{fill:url(#linear-gradient-137);}.cls-36{fill:url(#linear-gradient-100);}.cls-37{fill:url(#linear-gradient-101);}.cls-38{fill:url(#linear-gradient-123);}.cls-39{fill:url(#linear-gradient-129);}.cls-40{fill:url(#linear-gradient-121);}.cls-41{fill:url(#linear-gradient-122);}.cls-42{fill:url(#linear-gradient-109);}.cls-43{fill:url(#linear-gradient-108);}.cls-44{fill:url(#linear-gradient-106);}.cls-45{fill:url(#linear-gradient-102);}.cls-46{fill:url(#linear-gradient-104);}.cls-47{fill:url(#linear-gradient-103);}.cls-48{fill:url(#linear-gradient-105);}.cls-49{fill:url(#linear-gradient-117);}.cls-50{fill:url(#linear-gradient-118);}.cls-51{fill:url(#linear-gradient-111);}.cls-52{fill:url(#linear-gradient-112);}.cls-53{fill:url(#linear-gradient-127);}.cls-54{fill:url(#linear-gradient-128);}.cls-55{fill:url(#linear-gradient-110);}.cls-56{fill:url(#linear-gradient-113);}.cls-57{fill:url(#linear-gradient-114);}.cls-58{fill:url(#linear-gradient-115);}.cls-59{fill:url(#linear-gradient-116);}.cls-60{fill:url(#linear-gradient-119);}.cls-61{fill:url(#linear-gradient-144);}.cls-62{fill:url(#linear-gradient-145);}.cls-63{fill:url(#linear-gradient-149);}.cls-64{fill:url(#linear-gradient-148);}.cls-65{fill:url(#linear-gradient-146);}.cls-66{fill:url(#linear-gradient-143);}.cls-67{fill:url(#linear-gradient-140);}.cls-68{fill:url(#linear-gradient-147);}.cls-69{fill:url(#linear-gradient-142);}.cls-70{fill:url(#linear-gradient-161);}.cls-71{fill:url(#linear-gradient-163);}.cls-72{fill:url(#linear-gradient-158);}.cls-73{fill:url(#linear-gradient-160);}.cls-74{fill:url(#linear-gradient-159);}.cls-75{fill:url(#linear-gradient-162);}.cls-76{fill:url(#linear-gradient-154);}.cls-77{fill:url(#linear-gradient-152);}.cls-78{fill:url(#linear-gradient-157);}.cls-79{fill:url(#linear-gradient-155);}.cls-80{fill:url(#linear-gradient-151);}.cls-81{fill:url(#linear-gradient-153);}.cls-82{fill:url(#linear-gradient-150);}.cls-83{fill:url(#linear-gradient-156);}.cls-212{mask:url(#mask);}.cls-84{fill:#fff;}.cls-85,.cls-189{fill:#ed1c24;}.cls-86{fill:url(#linear-gradient);}.cls-213{filter:url(#luminosity-noclip);}.cls-87{fill:#ef4136;}.cls-88{fill:#6d6e71;}.cls-89{fill:#f15a29;}.cls-90{fill:url(#linear-gradient-38);}.cls-91{fill:url(#linear-gradient-33);}.cls-92{fill:url(#linear-gradient-29);}.cls-93{fill:url(#linear-gradient-32);}.cls-94{fill:url(#linear-gradient-30);}.cls-95{fill:url(#linear-gradient-31);}.cls-96{fill:url(#linear-gradient-36);}.cls-97{fill:url(#linear-gradient-39);}.cls-98{fill:url(#linear-gradient-34);}.cls-99{fill:url(#linear-gradient-37);}.cls-100{fill:url(#linear-gradient-35);}.cls-101{fill:url(#linear-gradient-28);}.cls-102{fill:url(#linear-gradient-25);}.cls-103{fill:url(#linear-gradient-11);}.cls-104{fill:url(#linear-gradient-12);}.cls-105{fill:url(#linear-gradient-13);}.cls-106{fill:url(#linear-gradient-10);}.cls-107{fill:url(#linear-gradient-17);}.cls-108{fill:url(#linear-gradient-16);}.cls-109{fill:url(#linear-gradient-19);}.cls-110{fill:url(#linear-gradient-15);}.cls-111{fill:url(#linear-gradient-23);}.cls-112{fill:url(#linear-gradient-21);}.cls-113{fill:url(#linear-gradient-18);}.cls-114{fill:url(#linear-gradient-14);}.cls-115{fill:url(#linear-gradient-22);}.cls-116{fill:url(#linear-gradient-20);}.cls-117{fill:url(#linear-gradient-27);}.cls-118{fill:url(#linear-gradient-24);}.cls-119{fill:url(#linear-gradient-26);}.cls-120{fill:url(#linear-gradient-45);}.cls-121{fill:url(#linear-gradient-46);}.cls-122{fill:url(#linear-gradient-44);}.cls-123{fill:url(#linear-gradient-48);}.cls-124{fill:url(#linear-gradient-49);}.cls-125{fill:url(#linear-gradient-47);}.cls-126{fill:url(#linear-gradient-42);}.cls-127{fill:url(#linear-gradient-43);}.cls-128{fill:url(#linear-gradient-40);}.cls-129{fill:url(#linear-gradient-41);}.cls-130{fill:url(#linear-gradient-59);}.cls-131{fill:url(#linear-gradient-57);}.cls-132{fill:url(#linear-gradient-58);}.cls-133{fill:url(#linear-gradient-55);}.cls-134{fill:url(#linear-gradient-56);}.cls-135{fill:url(#linear-gradient-53);}.cls-136{fill:url(#linear-gradient-51);}.cls-137{fill:url(#linear-gradient-52);}.cls-138{fill:url(#linear-gradient-50);}.cls-139{fill:url(#linear-gradient-54);}.cls-140{fill:url(#linear-gradient-60);}.cls-141{fill:url(#linear-gradient-61);}.cls-142{fill:url(#linear-gradient-62);}.cls-143{fill:url(#linear-gradient-65);}.cls-144{fill:url(#linear-gradient-79);}.cls-145{fill:url(#linear-gradient-78);}.cls-146{fill:url(#linear-gradient-77);}.cls-147{fill:url(#linear-gradient-75);}.cls-148{fill:url(#linear-gradient-76);}.cls-149{fill:url(#linear-gradient-74);}.cls-150{fill:url(#linear-gradient-68);}.cls-151{fill:url(#linear-gradient-63);}.cls-152{fill:url(#linear-gradient-69);}.cls-153{fill:url(#linear-gradient-64);}.cls-154{fill:url(#linear-gradient-71);}.cls-155{fill:url(#linear-gradient-72);}.cls-156{fill:url(#linear-gradient-70);}.cls-157{fill:url(#linear-gradient-73);}.cls-158{fill:url(#linear-gradient-84);}.cls-159{fill:url(#linear-gradient-85);}.cls-160{fill:url(#linear-gradient-82);}.cls-161{fill:url(#linear-gradient-83);}.cls-162{fill:url(#linear-gradient-89);}.cls-163{fill:url(#linear-gradient-88);}.cls-164{fill:url(#linear-gradient-86);}.cls-165{fill:url(#linear-gradient-87);}.cls-166{fill:url(#linear-gradient-80);}.cls-167{fill:url(#linear-gradient-81);}.cls-168{fill:url(#linear-gradient-98);}.cls-169{fill:url(#linear-gradient-91);}.cls-170{fill:url(#linear-gradient-92);}.cls-171{fill:url(#linear-gradient-93);}.cls-172{fill:url(#linear-gradient-90);}.cls-173{fill:url(#linear-gradient-96);}.cls-174{fill:url(#linear-gradient-97);}.cls-175{fill:url(#linear-gradient-94);}.cls-176{fill:url(#linear-gradient-95);}.cls-177{fill:url(#linear-gradient-99);}.cls-179{fill:#58595b;}.cls-180,.cls-190{fill:#bcbec0;}.cls-181{fill:#808285;}.cls-182{fill:url(#New_Gradient_Swatch_3-12);}.cls-183{fill:url(#New_Gradient_Swatch_3-11);}.cls-184{fill:url(#New_Gradient_Swatch_3-10);}.cls-185{fill:url(#New_Gradient_Swatch_3-13);}.cls-186,.cls-193{fill:#000;}.cls-187,.cls-192{fill:#a7a9ac;}.cls-188{fill:url(#New_Gradient_Swatch_11_cop);}.cls-191{fill:#be1e2d;}.cls-193{opacity:.5;}.cls-194{fill:url(#linear-gradient-4);}.cls-195{fill:url(#linear-gradient-2);}.cls-196{fill:url(#linear-gradient-3);}.cls-197{fill:url(#linear-gradient-8);}.cls-198{fill:url(#linear-gradient-9);}.cls-199{fill:url(#linear-gradient-7);}.cls-200{fill:url(#linear-gradient-5);}.cls-201{fill:url(#linear-gradient-6);}.cls-202{fill:url(#linear-gradient-107);}.cls-203{fill:url(#linear-gradient-141);}.cls-204,.cls-208{fill:#939598;}.cls-214{isolation:isolate;}.cls-205{fill:#e6e7e8;}.cls-207{fill:#d1d3d4;}.cls-209{fill:#c2b59b;}.cls-210{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: 716.11,
    width: 3095.24,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 716.11,
    width: 3095.24,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-213"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3096,
    height: 88,
    transform: "translate(-.61 715.86)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4120.39,
    y1: 449.26,
    x2: -4120.39,
    y2: 352.94,
    gradientTransform: "translate(-3595.37) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b7b8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4082.97,
    y1: 490.56,
    x2: -4082.97,
    y2: 311.88,
    gradientTransform: "translate(-3595.37) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -4061.49,
    y1: 308.9,
    x2: -4061.49,
    y2: 493.36,
    gradientTransform: "translate(-3595.37) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 308.9,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    y1: 308.89,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    y1: 308.89,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 618.91) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 624.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 630.42) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 638.08) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 647.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 657.16) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 668.33) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 680.43) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 693.77) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 707.63) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: 308.9,
    y2: 493.36,
    gradientTransform: "translate(4527.6 722.49) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 737.8) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 753.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 308.89,
    y2: 493.37,
    gradientTransform: "translate(4527.6 770.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 308.89,
    y2: 493.36,
    gradientTransform: "translate(4527.6 786.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -4061.49,
    y1: 308.89,
    x2: -4061.49,
    y2: 493.37,
    gradientTransform: "translate(4527.6 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -4104.46,
    x2: -4104.46,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 618.91) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 624.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 630.42) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 638.08) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 647.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 657.16) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 668.33) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 680.43) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 693.77) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 707.63) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -4104.46,
    y1: 308.9,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 722.49) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 737.8) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 753.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 770.06) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.36,
    gradientTransform: "translate(4613.54 786.51) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -4104.46,
    y1: 308.89,
    x2: -4104.46,
    y2: 493.37,
    gradientTransform: "translate(4613.54 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -4082.97,
    y1: 310.39,
    x2: -4082.97,
    y2: 493.86,
    gradientTransform: "translate(4570.57 802.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 159.36,
    y1: 400.05,
    x2: 159.36,
    y2: 259.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 306.57,
    y1: 400.05,
    x2: 306.57,
    y2: 259.24,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 398.49,
    y1: 491.35,
    x2: 398.49,
    y2: 409.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#1f0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4a0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#640000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 321.62,
    y1: -823.55,
    x2: 321.62,
    y2: -905.11,
    gradientTransform: "translate(736.41 -388.24) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 181.43,
    y1: -770.58,
    x2: 181.43,
    y2: -702.74,
    gradientTransform: "translate(1160.78 320.53) rotate(-114.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 181.43,
    y1: -710.53,
    x2: 181.43,
    y2: -763.6,
    gradientTransform: "translate(1173.96 466.54) rotate(-103.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#938167"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 181.43,
    y1: -757.85,
    x2: 181.43,
    y2: -715.87,
    gradientTransform: "translate(596.22 -275.7) rotate(-180)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 181.43,
    y1: -720.69,
    x2: 181.43,
    y2: -753.54,
    gradientTransform: "translate(1173.95 467.37) rotate(-103.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d8f8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 398.07,
    y1: 306.04,
    x2: 381.68,
    y2: 306.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 264.18,
    y1: 717.26,
    x2: 264.18,
    y2: 530.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 264.18,
    y1: 547.37,
    x2: 264.18,
    y2: 706.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 264.18,
    y1: 574.21,
    x2: 264.18,
    y2: 673.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    y1: 653.93,
    y2: 593.73,
    gradientTransform: "translate(793.04 200.32) rotate(74.24)",
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 264.18,
    y1: 682.04,
    x2: 264.18,
    y2: 567.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 264.18,
    y1: 607.68,
    x2: 264.18,
    y2: 642.15,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 264.18,
    y1: 637.74,
    x2: 264.18,
    y2: 610.89,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 926.45,
    y1: 550.01,
    x2: 926.45,
    y2: 556.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    y1: 555.88,
    y2: 561.59,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    y1: 561.75,
    y2: 567.19,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    y1: 567.51,
    y2: 572.83,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    y1: 572.94,
    y2: 578.7,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    y1: 578.91,
    y2: 584.9,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    y1: 585.22,
    y2: 590.22,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 926.45,
    y1: 590.43,
    x2: 926.45,
    y2: 595.65,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    y1: 596.62,
    y2: 601.73,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 926.45,
    y1: 602.49,
    x2: 926.45,
    y2: 607.6,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    y1: 608.14,
    y2: 614.04,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 926.45,
    y1: 614.44,
    x2: 926.45,
    y2: 619.34,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 906.51,
    y1: 549.97,
    x2: 906.51,
    y2: 626.18,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 946.38,
    y1: 549.97,
    x2: 946.38,
    y2: 626.18,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 807.95,
    x2: 807.95,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 807.95,
    x2: 807.95,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 807.95,
    x2: 807.95,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 807.92,
    y1: 573.42,
    x2: 807.92,
    y2: 673.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 807.95,
    y1: 642.51,
    x2: 807.95,
    y2: 605.26,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 807.95,
    y1: 637.62,
    x2: 807.95,
    y2: 611,
    gradientTransform: "translate(677.94 -388.51) rotate(45)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 1044.64,
    x2: 1044.64,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 1044.64,
    x2: 1044.64,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1044.64,
    x2: 1044.64,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1044.61,
    x2: 1044.61,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1044.64,
    y1: 642.51,
    x2: 1044.64,
    y2: 605.26,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1044.64,
    y1: 637.62,
    x2: 1044.64,
    y2: 611,
    gradientTransform: "translate(318.35 -352.26) rotate(22.5)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 551.95,
    y1: 520.54,
    x2: 551.95,
    y2: 657.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cccecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#bec0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a8aaad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#919396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#818285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#757679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6e6f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 459.91,
    y1: 640.48,
    x2: 459.91,
    y2: 665.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#212122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 551.95,
    x2: 551.95,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 643.98,
    x2: 643.98,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 586.62,
    y1: 525.3,
    x2: 611.02,
    y2: 525.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#28292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58595c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1926.83,
    y1: 540.94,
    x2: 1926.83,
    y2: 457.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9c9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#545152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1300.98,
    y1: 670.46,
    x2: 1300.98,
    y2: 514.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 1300.98,
    y1: 683.23,
    x2: 1300.98,
    y2: 691.17,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 1300.98,
    y1: 651.72,
    x2: 1300.98,
    y2: 682.75,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 1300.98,
    y1: 495.78,
    x2: 1300.98,
    y2: 636.74,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 489.29,
    y1: 372.9,
    x2: 489.29,
    y2: 503.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 2669.2,
    x2: 2669.2,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 2669.2,
    x2: 2669.2,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 2669.2,
    x2: 2669.2,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 2669.17,
    x2: 2669.17,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 2669.2,
    y1: 642.51,
    x2: 2669.2,
    y2: 605.26,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 2669.2,
    y1: 637.62,
    x2: 2669.2,
    y2: 611,
    gradientTransform: "translate(214.79 -596.56) rotate(13.28)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 2789.61,
    y1: 542.49,
    x2: 2789.61,
    y2: 462.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8d8f92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6c6d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#545456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 2782.66,
    x2: 2782.66,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 2796.55,
    x2: 2796.55,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 3009.25,
    x2: 3009.25,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 3023.14,
    x2: 3023.14,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-5",
    x1: 2910.01,
    x2: 2910.01,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 2910.01,
    x2: 2910.01,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 2910.01,
    x2: 2910.01,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 2909.98,
    x2: 2909.98,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 2910.01,
    y1: 642.51,
    x2: 2910.01,
    y2: 605.26,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 2910.01,
    y1: 637.62,
    x2: 2910.01,
    y2: 611,
    gradientTransform: "translate(1293.62 -1874.9) rotate(45)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 2318.24,
    x2: 2318.24,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 2318.24,
    x2: 2318.24,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 2311.29,
    x2: 2311.29,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 2325.18,
    x2: 2325.18,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 2548.83,
    x2: 2548.83,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 2548.83,
    x2: 2548.83,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 2541.88,
    x2: 2541.88,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 2555.77,
    x2: 2555.77,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-6",
    x1: 2428.45,
    x2: 2428.45,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: 2428.45,
    x2: 2428.45,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 2428.45,
    x2: 2428.45,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 2428.42,
    x2: 2428.42,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 2428.45,
    y1: 642.51,
    x2: 2428.45,
    y2: 605.26,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 2428.45,
    y1: 637.62,
    x2: 2428.45,
    y2: 611,
    gradientTransform: "translate(423.68 -881.82) rotate(22.5)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: 1750.03,
    y1: 502.52,
    x2: 1750.03,
    y2: 549.38,
    gradientTransform: "translate(1318.3)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 2082.63,
    y1: -2994.99,
    x2: 2082.63,
    y2: -2976.55,
    gradientTransform: "translate(5171.91 -2448.36) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 1770.98,
    y1: 505.05,
    x2: 1770.98,
    y2: 525.05,
    gradientTransform: "translate(1318.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-11",
    x1: 1753.41,
    y1: 479.38,
    x2: 1753.41,
    y2: 549.13,
    gradientTransform: "translate(1318.3)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-12",
    x1: 1761.4,
    y1: 458.4,
    x2: 1761.4,
    y2: 627.11,
    gradientTransform: "translate(1318.3)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-13",
    x1: 1761.4,
    y1: 561.75,
    x2: 1761.4,
    y2: 628.45,
    gradientTransform: "translate(1318.3)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 200.3,
    y1: 217.41,
    x2: 200.3,
    y2: 524.42,
    xlinkHref: "#linear-gradient-109"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 112.01,
    y1: 563.95,
    x2: 112.01,
    y2: 529.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 98.52,
    y1: 623.31,
    x2: 98.52,
    y2: 630.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 34.17,
    y1: 524.27,
    x2: 34.17,
    y2: 632.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 1929.29,
    y1: 1.17,
    x2: 1929.29,
    y2: 491.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 230.39,
    y1: 435.65,
    x2: 230.39,
    y2: 419.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 210.85,
    y1: 424.06,
    x2: 210.85,
    y2: 431.19,
    xlinkHref: "#linear-gradient-139"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 248.42,
    y1: 424.06,
    x2: 248.42,
    y2: 431.19,
    xlinkHref: "#linear-gradient-139"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 229.64,
    y1: 425.01,
    x2: 229.64,
    y2: 430.15,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 86.54,
    y1: 504.11,
    x2: 86.54,
    y2: 515.29,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-135"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 9.42,
    y1: 360.52,
    x2: 20.21,
    y2: 392.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 14.66,
    y1: 264.83,
    x2: 14.66,
    y2: 356.09,
    xlinkHref: "#linear-gradient-146"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: -5133.88,
    y1: 500.41,
    x2: -5133.88,
    y2: 488.97,
    gradientTransform: "translate(8075.67 989.12) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: -5148.57,
    y1: 488.86,
    x2: -5148.57,
    y2: 500.92,
    gradientTransform: "translate(8105.05 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-135"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: -4419.78,
    x2: -4419.78,
    gradientTransform: "translate(6647.47 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-148"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: -4434.48,
    y1: 488.86,
    x2: -4434.48,
    y2: 500.92,
    gradientTransform: "translate(6676.85 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-135"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: -3705.69,
    x2: -3705.69,
    gradientTransform: "translate(5219.28 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-148"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: -3720.38,
    y1: 488.86,
    x2: -3720.38,
    y2: 500.92,
    gradientTransform: "translate(5248.66 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-135"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: -2991.59,
    x2: -2991.59,
    gradientTransform: "translate(3791.08 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-148"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: -3006.28,
    y1: 488.86,
    x2: -3006.28,
    y2: 500.92,
    gradientTransform: "translate(3820.46 989.12) scale(1 -1)",
    xlinkHref: "#linear-gradient-135"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 1523.35,
    y1: 666.29,
    x2: 1523.35,
    y2: 605.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 1817.21,
    x2: 1817.21,
    xlinkHref: "#linear-gradient-156"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 2111.06,
    x2: 2111.06,
    xlinkHref: "#linear-gradient-156"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 1670.28,
    y1: 662.69,
    x2: 1670.28,
    y2: 494.97,
    xlinkHref: "#linear-gradient-156"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 1964.14,
    y1: 662.69,
    x2: 1964.14,
    y2: 494.97,
    xlinkHref: "#linear-gradient-156"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: -4272.32,
    y1: 612.6,
    x2: -4272.32,
    gradientTransform: "translate(-2455.11) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-156"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: -4272.32,
    y1: 558.92,
    x2: -4272.32,
    y2: 551.73,
    gradientTransform: "translate(-2455.11) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-156"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: -4272.32,
    x2: -4272.32,
    y2: 494.97,
    gradientTransform: "translate(-2455.11) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-156"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-212"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-211",
    width: 3096,
    height: 88,
    transform: "translate(-.61 715.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAADBgAAABYCAYAAADlNaVTAAAACXBIWXMAAAsSAAALEgHS3X78AAAgAElEQVR4nO3d25KjuNqu0U8CO7t7Hqz7v9E/uisNWgcg0BawDbYEz4jIMmYrBCadlF6kjDGm73uxP8aYebg30pst04wYd75wWt+P74f57PRtr3b5J17HYWPMU++HdYz7Es4TTDd2ucRPvzAt+uk3zCNGxBgxRg4bJyLj6zx+HrfPtJ+fezTPUJZg3Mp63eHb7eadl33fy/1+T5RBpm2lpiXnX5j28/MjKJV5feryosCHpE9Ezl3U4Ynzl/MWxYlPSs5d1GPl/OW8RdFM/h3n7inZ+zbvM/Mp8tFzZdzux8/Pb23Xv6fGds+3Xe5zlo57nTiD/MnIOYx6PHnfnvMXReL+J87CJIaSk4GCGeffaDROas/7otO/l7lHeb17o7bN5HW2+937skrU4jxKvTfdncedd3VYyVS2YVR+Hbf7Ld4PZ3l/3DBwu92icUvL3263qRxTeew8XlnnMt9ud2/96eXmabfbTUQpUaJEqXH+6b0kpw3lGraulMrMPw/fbu24fOpH++/18Hprl5YZt+n8TPNrLXpaz/Jw27bz+3G7WunkuKZpRGklWutpmp13GBdMG8c1TRONtz92GfendRtse+eGUmKUmQ6G1lr6vhet9dDIezzA04GSuYJF9dLoRrTS0uteTK/l8XiIjMO97kUnXvVdz6EC08vv70NU30uvRKS3vyjsay+9aPlpWy9Y8PvnzzCslZjeiLKN6pUSY+b37c/PFCD48+eP9FqLnoIE7rCZhtu2FWOM/Pfff5sDBLYB/LyMrC8nRm7tTf777995/jAUkAgJ3O83+fe//1bnc8fd7zf599//ZGrIbxv8ew3/7S8Ou8x92p/hkJh4+WDa/f4z1F+qPEGQIBxn6zD+cUMf88/ff/+dDi5sGHe/37PHxYZe7Dawxbbf+pu/G/DH1IesVzTHrEQ7HTeO2Ye90VDgqZmwrzePG8fsS15s0LBpBhyH4F2daHhRp40NDRYn4PPqbCDS3tphoLBybZdpzFDt/oiceZ/Otj/e0A77888//7y/kkvY+T7n0zPjddyjrteOx47j9gXc96wX9z7rxf3PunEfNIdQNAAAONL//d//zW9SDfIDbkP/6N7q1Fh+nsfdxlqIIBUo+Oeff7xthmW0035/fxfLHe+HGh4YnpqYGKm19oNSqVCCM05rLUbMsMxc9Oz83jbseDXVRjLY0OhGZNzGaoBBKWm0FhGR2/0eBxKcIIId12g9laG1IYbUcuO2tJ1fiRcWsMvpILSgdeOFEmxowLbDj+fX03jdzCEBL3zghQvUND78yY13zy0jIq2dYIzZ/KrHEEEvWoY6n5NLShnp1dh4WxlRZggqNE0jyijplREtfpDAPsm/N0ZE96KNiOm13G4358n0nSh1E+M08p6WV0r0+F7/9TMv0w2vTdMsNuhv21a6rvOegt/1vbTOcnNPB8s9FOQbwy/9iNxubT6AIGODe2f+IVBwD6bJpmDB7X4Ppq2HBMJeAdLzuuuSYBkjPz9/TcEAv+F+sL+JXh1+fn7y+xUEBf7++++VOnBCC85yqaCDLX+0jX+CgMHp/3h/bgf5j7TQ9p2k7lIOqL/L1J0I/4n6DuruPeX/J/D9J3hKxGWO0fM7+vQS1OUOc7+yQO34zrQfGsDth7rcD9+t9rO+89TjVjvV5eXrUWSXuqQeR59tkPnP/4L/BDv9ceA7/Pv43v4e6u993C9+H9/N30P9va/8e8fl4/v3e6i/9735d8uT9Rf93QIAALAzrxF/cob0U/69kEGuIf20jXyo4J9//smGB9LL+NP0v3pcygxftbzvW0Ob2LZtp2GR4aHhi8uISNvMy0RtbBKG+Wf3n/vid7+hTM78USDBGbIN9+2bsR7utieGeMF5fiescJ96SbCLjSGCtp2G5wDBUO+3cdq0eiXSNO003Q0c3G7tGG6Yl2+axgsLhL0l6GBao7UfNgiDB1OYQrwyrP1MjFNPY5voVE8c09FJhQlExO+5oDciWqQ3/dCVQi/SixKt7KuWXvohgKCVaN1L3xvRppfH4yHaaFEyPAlehozCUEojY48IRtrmNjU6fzx+RYkWpUS0VtL3ZjoxhqFhQaNEZGzc//v7Z05fKO01FLf1kqKbZuiOwoYOggbuU08I2sjdzCECL7wgTsN0NwwgQ4ih7zrpul66vpNbOzdw9+ePG8S7AYL7/Tat0wsWSHp++94+mT8cL0HD+amBvRj5uf+I20jfvbi487rLiJEp+CDOOCNjo3y7b842tw+720kMj2X6++9/piDD0OOGxOVxwgNh+Zfmsa//jAGDsm8OnuUG51luMu5wo2rzTEc5wz5sK0D5Nw2vcSzq2AeRT99EPcYZ9kFkqSC5KX/9/HXI9t5xyFqLOUal2b9iOH7fsG8F7V7dHL8N9qskjt+3FHoMOX5PKPAYcvyetE+Fcfy+7f2Ke3YN/xv/A6zse4Rnuc+5bePsxydd4x7btjm2znSks+yHyBXuta1P3TLDp1x7P/5Hb0UAAAAAsCjV68AUHMg1ds+vJDuvUm6QYJ4eBwnC9xumLbR/bW+t90fj1M53bPwfth9ub7fgj8zhzRBIiNsS36YG/nFF3G/3aJnbrU3s7/Dm58dtszzOf7/5IYGgZ4O2bYcSGuOFBKKwwDhON42IyNTOPPmE/7Bh/tQrgExt06PltA0Y3OeeDYLeAcJ1Kme9bXtLL+f1PDAEFVqvt4OxPEF4QWvt9VSglZ6CDmFPB3OZnCCMGPHjH/YwjSGD0JhTGcIFZgwTGC29mKHXAWVEeiVGjb0MyHjymyGBYXojveqHHgzCp9YnGvRrfR97FDBTzwKm70XfGwmfgu8/9X7cvnafjj+M+7m10dPvf//8CZ6i33vrc6fd2lbMz4/89+ePtw5Z3B8lvQw9KWitpTXN8IFRIjKGJkx4IVIiP3/9iOn7oRKNmT4E06vzobMf8uafZggy2B4YFua1H8Tb/e6FH+5ODwepC8K4u84HWYbuUrLbGOq70Vq6bqiHeX3zPNMZ5m3v+em25wsznjP2AjbP5y8fDbvbmIb95b3uXi6jmDuoL6t+D6rfgauq98DVW3KpvPCo9QDWWepR1YXHrL4DWV+JpdJCY1k9B7WekjqqLDS2qePg1lHKUVWFxWvKO8jzU6oAAAAAAAAA4FqS90cTGYJEfwTbNqBE/t/9/8nv7++0xK29TdNST+mfX+LUQmq8Ett+12nr3Bu53cftZG5L3+43r+21HxSI3X/u0ndOm1w38BDuy/hej+3G27aJggHzfM7ySubG+1ODfJGwUb7baP/n557skSA1Tms9ln3uXcCb3xluGi02wjHU5Vzu8LVt5v0bejtw1u0MN432ggbu/jRae/Prxjb+90MAWnmVnQghpIITQwBBbLv1Ua7ngunIGmNM3weN9Y0ZewuQuCG/MdJ1nUzL9EOPBHYZO//w5Ph53OP3MZ68zvp6kx3Xto38/v5GDf3DsqYa9nddJ0rreZptQD4Nh+9lDDB0U5Ch73ppb7do3fbnz3//LQYkbsGybiAhHUaQqWy3203EGPn3v/+mBvxuY/55eGgA7/VMMO6TBOtMrieY121Qn23U7wx3/dBbxZZ5jRl7X5jGOfM48wWDwXpSy/jz2F4solmyI9IT3HfThdMZ+fv7m1sRAAAAAADA5azdeH6lYfVLTbEPab/9gbIf2u78uZVT9r3UUfb1z24JygtmfBs1kkClnBAH1UVtOKiMk+MAi1ALEyriQjjYl6+By1fAVdV/4Nv2zPdEX1vx5crP/cXdNvD9+6NO29Vo/duntW0btRFev1ZsN/RGEDwE3Bj58+ePdN1DmraNejmYX+KeEHSjEyEBp+G/zD0s/Pz8JIMEzpqDcWPj/0R5gsGhLFrLfWzI721HuaUfJjRjLwQiw8PCvXUprzTStK33/ubOb4MC43xRTwnj9OE8GY+ykbmnhESQQGs9rbdpwsb+eu4dQfshgKgHA3e9TqBCN1rats32crAUNLA9GGwNJbRKqSlk4Bra57tPdnenDSvreyNGGVFGjaECI8bMvRPM69Fyu9unyg+BhL43om8q3dDeCRvMvRD0os24/n4OHBhjht4RxpDC75/fKdzg/eQaqo9BA6VEtG6GBvONEdPKGEAQMbZHB6dB/99//y1d10nXddNFwW/sH7yXeb/CgMHtfl8OTXjr9UMCd5siEtkYSphDB/fbXYwY+e/f/8SGAMLX6SLkvP7c7/Lvf/9J665XxH9NrGvuSSBzHNz3wYy5ZdwLfDhPPJQbkZ6wFjIAAAAAAGBP+zbyPPYP2MLuOx+o4nospg5FjizMdc5FkWrrsag6FDmqQLXWYR0BgyXFnWBfQS0IlfAR167ka++9UAEfde3KvuzeX3bHv+2aFX/NvZYL73gJ0pW/Z2PLTxzg69yDqvh+6Ec28Azqcj8V12VR9SjCPeZY1P7U214uWLA8b9u0Xnvbm/c7b9vOLM3VtO3UoNa2mW3aZmXBYIJS8jP13mDiOZw3TaOntsrBSjLla6a2xPf7PTmPXX1rG/+P7c1z84uItM69bDd8cL/dnMMwbPdmAwDOfHa4bZqpnXPTtlMwwO9RwB93u9280EHcO8EcLmhvbbL3AhsUsD0fNE3jLdu2zvtwviBwoLWepucDAkEPBiuBhPhHZI5mBGwjfaXmEMBQp2Pj/r4fAwVDo3+vZwGnVwO7nt/fX9G6EVFGtBkb8Y/rGQ64EqPckIGS+/0+hhH6cXuJ4ICZy7AYVnAa7g+BhHn87+/vwnrjn+Z2k9/fX2nHRIcREWVDDP0QSJjeGyVijPz1119jwGLcD3sypxrnB9Pcst/vd3+cN13SQYfxQnW/35OBgy0BAbvdeZvz9FQIwc73c7/HYYPpwzz9kw0QeO/F6R4msZ742pgPDIQj/P9IW1kOAAAAQJHKaCBX5l8QZZZKCi6Yq8xCFlmqIguVUl5BiytRcQVaU1aByyqNFFigLcoqdFGl2bkwZXx/2ktRR+pwl9rbS+3skmtUxDX2cnSpnV1zjcq4xl7KhXZ0q/NXyPn3UIrbybbNNvX5oMIqxVFsyYotWKjMghZZqiILlVNeYcsrkRRaqCXlFbi4EhVXoK3KKnhRpTns/uh77VrdRuvGWXBo7J5um7rUnjUcMYcKgrJFyy3vx9T434jcbe8CJtzXYR1tEGQY2h/H6xQxXuN/twBhu2Mx87ypeML958d/ePutlakvhVRgwD6ZX+u49wERUe54JXK73adeCbzG/848tpG/1s1Uznbq3WCebtchoqRtGicocJvmdecZggKZ3glszwciUVggFR4YyjOHEcKfoUcI930YVJBg/pgRJ2CQm2mmxD0T7YrtgRyGh9V6jfpFvOCB2/NAGGCIG/4/pDFq6FVA2wb7cyhhjCV4wYSfu556SDB9L2oMJYiZl596ZtgaKGibaZlkTwMyTxPtLDvue9s2Y88KSoxpnLL4QQRljBinmn/GD4vYY2M/ZOOwiHjvjYjc7jfpuk76rpOu74d0ThAgcMMJtiypkMH84Q7DA/58YdhgSDbF4YO+66cS5y604QXodrt5F6nUPPkLevQm/ftlHLkUMlhZLQAAwGncotR5oLrvQdUVeNX59kgq3qlqC550rr2RE+xQ9TswOc+eyEl25hQ7cZK9GLEzRal/D0Ybd2Tx+39VlVFVYTc51R5VuzPVFjxynj2Rynem6sJPzrEXo+p3pvod+MoeLDbMrrJKqyz0qlPuVbU7VW3BF51ur6rfoep3wHOuvZGT7NApdmJyrr2RE+3QaXbkRHsiqztzuwftUzNtVaNpRqQdew1ITbMLG/Efqh1MngYa9++UlYaq0RgzPlA+0w64Ddvgjv94jf+ntr5OWCBojOs+HN3+3KMH2NjG94Nb207txW+ZHgjc90rGp/Pbxu8iTs8Cbm8A87TWCyFIdljrZmiY740P5h17DHCDAUPAoJlKOfWEYHtJCAILjX0AvQy9P4RhgjgwMAQL7reb03uB34uB1k0QftDBdL9HgzA84OUDEuGC5DIm0YNBGDSwAQAR8V5tjwU+29h8rtihgX0rTdPI4/GQvu+lkfkkk2nYLh8Oxz+pngxsOOH3z++Y5jBiTCN93429I4goM/SSINOHYXhtmka6vpe+76TveidQMJcnVY5kwGAKJbTe9KZp5WF7ShBJLu/Nrxv5fTzGavWDBbnhodZEGq2l03o6uGplmf+17RBI6Lr4YpLZ5hQ0mI55Om3kvj4ej0wYYH7vBgpy84T7684YXNPcidHTuJK/O569OAMAAJxQGU8/Sqj6y1jVhT8ENRI4RYWcYid2Q204TlUZp9qZt1ATo1NWxCl36mlXqYXdejD4aIXVc3TqKal8obD11E4VJf1aIauonTpK+dVCll9D5ZdQCijk1wuwqqQSFnn/s6QKekn1O3AIaiXhNJVymh3ZBbWRcKpKOdXOvI3acJy2Mk67Y0+7Qk3Y9qpee9jhRZpmaPgdtlF9dlz0kO3M8M35O+XZum+dh7unGvQHhRMjQ4P2vu+lD+cNjcu2t3ZoY9w0fjAgMzw01Jeo54FwXvvkfrsfUaP/xHKNt0wrzgLesvM6h/dTHc8Fmv6dAgO2zEHowBiZeiHwe0AYG/yPQYL7/TZPd0IAbs8BYYjB7SHBsj0OxMtradtgWjQ816vbg4H7Pvdqq1sppV7+y9k28heRp17ncIDI/CT/4Kc30wfL9EZ60zs9HaSWW1iXicMI8zbGkIEyY3cQrTTNsL65Z4R53fZCEoYBbLhg6OYkDhtEy6RCBmMowQsv2Mqehm0ZxG9gn5jXngy56dG6brfkvL+Px/BhsckRpcSIyN9//y19143dgMyXM799vj/+fk90qZJ8P79bmye1TKYwIkLIAKjFbv+5XZNqLi7VFLRa1PDBqqvg6gpcFWr3INVXbPU7UCRq9QCnqdTT7EgxqNEdnbYyT7tjH3eGmjzkHsxbFfPdWv3q1t/e+PdKT73VtuW9Nn7Butttw9/Zg722enuhYfYZfmdWobqKrq7A1aGGP6DqSq668EWjZg92igo+xU4Uh1o90Kkq91Q7U4Taa3Ro/O8/wd9t29u2N0m2jw3aqy6Nn7bhrNe21b3d7lOj8txT/be+tw8Z/8u2010xNaoP1uM38vcb9t9ut+R4tyzeE/6T5Z3fhfvghgFS++uGFqZxtnF+YBrv7EvbtlPLZGOGngm8HgZsI/6g14HhPnrcW4E4rzY0MOy3nXee3wYG3KDBPDy/14leD2zPB8P6m2k519yrQTo8YIxJdkBgX71ptrn49H7gLbz0vu/6qUG/nZbrkWBumJ+ZnljeLvN4PPwgwbjM0INCahsixvTS90aM6aeAQq7nA2NEfn//xKGARIih77tpO2JkCD4MUQSnLCLJQIIY+f19TNPcwIFumsR2RbrHw2/0H74GIYHc63S8F+ZxG/KH06beGIJ5H7+/z28zZKKBpNVfRBvXszrXxvX8+f3dtB0Ar3vlPynOqvYv45dU5EErslDI4GhVpvgDVnwBIRylqlR1sKoq7OVwdCpR7YGqtuCnVuJR2SVgsH6z9ZjV77qy/bbymfbHhdXtacq6z5aW1sA9zzKvhdio2INXbMGQwRGrVBUHropCQjhSVaruoFVX4MvhCFWm6gNWdeFPrZQjc7vd5geWj+2M43umYQIgbWXyvusJZrJP8VfO9FQQYMtwKiywOuyGApzhxg0rRNuKl2maxt+18U3TtNll2raZ21HLEApR3nzzqx4fsK7GxvtaN9OwbWTvN+gf1nO7td5251BBG4UOmrYVWyDd2Eb/dnta5lDBvI056DEHE4bpjdcrwdD7QevNM1dtOlwwr0tH8+bei4horeexWwIG4bhtwyL20D0eD2+6DQZ0fRfN6w4PYQI3WGC84IAdbppGfseG33NPAE64ITP8++uGGPI/cw8FRn7/uI3r5xDBELwYy+6ctHa47zvpu150o/1QwxSOmN93jy4bLJjqZy1gsDGEsBQwMDJ2obJlHQvrfPw+pmM6TZKE1HmXHLGyrsQ8IsP5BHxaKV+KAADAC/hFjixODgAAasRv8JlO/McBsBWfJQAAToxf9DgMJxcAADW4ym/sve6PKq0TwYA4CDCOXZ0vXap5Pltue5xa58n+W0IB0zZeHG7b4Wn9caP/J4ILmYCB0/B6aLvczuGC+cn9c28CWg1P/Q8DAErrqPH/7R73RBC+2p4I3HJNDw1Rtr7bKSQw7NIcInimtwN7+rVtO7UJd3sisKEA932beYCJGyBwlwmnp8IE3nIiYpSIVisBA9dS+GBrECHdcF9EZH28Fw5w1jUPD/P//v4G88/rsWGGVJCh7/vxx4jpe9FNMzf293oWsKGE32m73nxi4vHOuHk+SYQA/DBA13WZ+ZxxiWmN7RFB7L77r6lt7fqaWffD9sjgnyj+22h6PPb5dTy3jaZpvffe/OO6Hl0XrgUAAAAAAOAyppvVgSL+0yH9RItPlyKpiFJQP8uyhfh+6Y4oQe6zvKfv1xzwosNOXj4VqBNnLqpz+EnLpwL14uxFFT52ovKJwHZNyfdERbjvtwV1tK7g+6Mi+5fi+fuj6dDAhqU2Ca8z+cPhT2nGRufLjfyHf14PIDjLq7mRfdxTgD/OXVdquh3XNI3XxrptnfUnlxkb9Le3zHxOg37dDGVu/Z4I3GHbM0AYBlAyPP1/CDGMvQEo7fRO4AcfblO53fGJ9TvhBBsaiNc3nxOpHgrsj5X7PbWJcw4opeYqstZCBmu2LtuNjbNtbwTusn7jf+P1euCGBYaeAtIhh8fvI27U775PBBfmZdzp87AXWDBGfh+/mfXP45oxpDD3lPAbzJ8YNmZ+wr6SOAwQBQXsOt4cl+hxYK/12iNqj+X7gYCV6RvXYS+q7rxL23KndXZfAAAAAAA4mbduPhWijNvcB0k/OeGUTrtnBf8n1t7OuVdyqmN4hms+PqvOMx2nsfkE5EzFd3Dm4StePvE4Y/F5nHX4qCdOuKbR6zNV4PSfMZN9czqn3rsT3Vfb4rR7VngI4Rnz/dHXggM576zKlumZ2mybJhkgmMryxLRm6jFgORDg9SawOv/yumxjaWPm3hm01lOIYNiWPzw8kd9I296SgQERFdVLe4uf/j+FDhLbacbl3Z4H3Ib9uR+RoU271s3US4Hbq0LYQ4HfK4HyvpuocV/DZVJyvROs9VqQmD8dMEjN/E7oILd8roeDznkyvG1s/1zPBya5ve7ReSGAOTCQW59Mjf9/fx8yhx6G+cSI9Gbs8cAMvR802g8UhL0WuKGEtV4PmrYZ66Oftuc24pe5REMgYc+wwe7jhuEpLBKfDdHIvUIHbepimw0U+OVYWoaAAQAAAIAaNZkuE8vm/RGMjaiuF7x5/+uKqLEnmWgAG1FjG70QQKrzu0GJcjeWge04dfAyM/0DvIwzCE+5WMNAHOvIM6feQHXchgbrqLI3cF/0adTYi7g/+hJq6wVP3Cfd4/7oq70T7GkKBYj44YG191HwYPhnaJi/HgrIj0tPV0pH29Jaja96IbwwD0/1OK7IBgTcfWzaZu4pwHlt23Zqr+2GS1p3fjWUxwYBbKjAHWeHbS8OtgH/sE41hwoSvQ64YQF3nBgRpcfeEvTcW4JSSowxyZBAuP49KGdl0Vrf6cLgmUVzPRbkXudG9CY53R1+PB7BtGEbbrCg67pE0GCeL34/NCp3exvo+n6cLvPrGBiY1ztPe6QCBs72mqaNggdDMGKsoyBk8Mxw13XpaalgwEJIIDV9OoIr65p6MNgjUBCsw734vhIaWJqWGv9wgjAAAAAAUJNm4akGeB83er8lU/MckK+g2r+Nhs6lqKH6n+8C/Hg11BtetfHochKcEof17BaOMAf/tDi0V5E40hz80zrjoeVe6PHOeN7Ug+9gpaL6v43vLyUq9RAcdX9UJ9b7chNwlX0zcZ/U780VhgtS45RI0yz1WuAOp6drpbNhheFp/O5y8bpFZNN8UU8NtpG/zO2V27b1QgDua+P2imB7HHB7LRjHtW3rBQ6Whm0owC7nVLS47f7noILfg0HYM0EYPgjHJampRt7mBgx2fTzR1hSEm6awB84dlwsahMN93yfH2/ep0IAYkUf3mBIfU2Bhw3Cj79Pw49GJbrQfLpBhvLKXQ7eRvQwniOn7ueeDvhfdNImwwRxAiNbjDLu9KaxN17rxp2fCANkgwg7D+Z4DvJ3cNE/TNtPw5kDBq9MWyw0AAACUJXWzAkfb6S8F/uCoDoesVm8cOQ56tTh0NXvy6HGwn9K0T3x3pG6/gmr/Jr4z1Irq/6YXa5+D9lVU/7fxffcV3AP9ph1OQs7janHozoC/c66IQ3cmfHfcm3d/dOc/ae1Ds1dbVW8IEKxN9XowcGbWukmHDXIBgsR8Q9vjleUy4YKpR4EoPBAMq7CHh7BHgnaa3+vdQNl22cY5lnNvAlNPAmMQYOpxwOutIHwdG/w3Ti8Czvw2wJDq8aBpWnEbNtt1iIg0uhnDHPN+5nolcMvjtY1Xe8UI0lRQoOS23unF4BW5zbk9E7jzLb123dCrQLi8GzDo+s7rbWAOI/i9F/R2vkzw4NE9ol4O4nmHcY9HZ3dCoh4Osr0e2B4MUg33t46z699vXNd1/jzOdBF/+/N7tweDITH1fuN/k3p5Y33PTXt0DwEAYA9Ns2vmE4u+/Bc0f8BfAof5aj58xDnBLodDfjUfOOKcVJfFob+q5SN/vr9HdzzT+dAsonq2ogHeJ1BFW71ZUy8sTgPgTyjgE1BAEfA5HO6r+tKR54S7JA77VfF/LfgMDv3VxWdA+v5oskHqZG40nm7qvdgAXK3PlZ2ysGzrPLBbxC+6bdwfr2J88r7z/qXhzLS4t4E4VBD2RBC2DY4CAeGrUkOQwBnfuNu1AYMpNKHGIMI8zTb417qZejGYlxl7NggCCVPIwOsFwe+ZYFo2CAy47y2d6XVrDuJxQ4gAACAASURBVFN8RpEBg8T2k8PhuFz4YGgALyJGpDe9N63vei9UYMcbY0SJmqb9/j4kbrjvbGNs+J8LGKwHD8wYUggb6/vbfHSPZHjA770gHQjIzjNOG05KN+SQe03Uw7Qf/rbsurp+Dnq4Vyu31wk1fSji+aKG/fHI1XkSZ862eRa3M8/zsOcZACw4qiutK+APO+RVfHZUXHQci1MDyyo7QyorLj6L0wPbVHCmVFBEfF8Np8k37lvUUC/P2WmPTlYxJ9ud0ecbZ5cq95+eSDvRocehKj5TKi46PofTBNtVeLZUWGR8B6cKnlfBWVNBEVGW0k4Ze3/0ubaoRpom3WNA2CQ73VpbbZqux7beUdkSzWn11JJ+XodWzpP+nfLFw+thAq/XgHHcVAeJXgVSy67N07TD0/9t2+opCOCUp2n0QsP/eZxemK9pGtFKi9JD7wBzm/px/al12mCBDTwEQQGlhrDG1GuF004/vI+2dl8t1avBJ4ThApGFbMO3QwahsDhh7wauruv8hvzj/H3fez0ZhL0XuONy68iHCDLvvV4Str3/nZ70b7dr1+u8Zhr+x/PE87rzaK0WwwnPBBnW5u1yT/xPHMZksCS9dDwlM+Om5Z9YtnvQg8HVDb/Ucoq6hL6texCoeUdDyOBt5/pE4bsufDZdeNexP04n7O9CZ9WFdhWfw2mF45z87Dr57m3hdQH+ii/XYTmH8MWSFLADBRRh9EJJCil8IcWQp0vyZsG55/m8cs4VnMvFz6yL7z6OwWmFY13sDLvY7uKzOL3wGSc/006+e1s0bWsb6IoRp6G+a/2Z7ssPmX9j+S2NzW3j9ikoMIyc1/tsjwRPDA+9FDiBAec12+vA0EI/uczQ4H9ogN/YfQoCAu7w0ODf7ynAXb87To0PZA8b/8dBAiVt26R7HgiCCl4vBomeCdxl08duqsyvSoULRFZKVlrIwJUrWtgrQfjeHXYDB+nQgYgfGPDneTweT/dgEA1PAYP08NBTQrz81IhfJB43hZTWezHYNs2WJzP/0jRnXW4D5Wx8INvWf236vH3daOm7PjE1dc689+Hs6MXg8pqmkCc1FXu1xlVxSqJMnJmHoWpRKE5NlI+z9G1UISrAaYqS0UB4Cz7FX0PVozCckigbZ+hHUd0oDKck6sIZeziqGIXhlETJmqaJ2u3qzfdM47NbJdqj6oPaF2qlpza6jW78AMAwOL/fMrxxvqlnAW96vseCxR4M1LAfIiK6aZYDCk4QwJ2naZpo+nDfeyiT1tprO9yOD5UOAwNhbwU2QDDNO4YK3PfuetzjXHqgIHS6gEEo1cOBO2x/lFLTNDdg0HW92Eb8bojAXd4dDsMF7ja9VyPS9d3LQQQ3YOA22neH+67PBwNWggRvhwuemL/r7L5MR2ZtcH63Ml3rZtpe13epGV8INaTnSc8HAAAAAAAA1KNp9O43ufa/Z/bkGs+2PwcUIlzd6sMzuBEKPIWPDPAOPkGXxykAvIWPELA3PlWnxuG9rKkBMPcRv7TK7+/X0/dH3zC0VR62OrRvfZ3WbjnjBq+6abwggD/4XJhgXlccGggb+LvLr82jtHL2w93uMNA0ejGckAoSLAUE7LZs7wW2Cb0bMBCJgwTzqxKt5/da62B7Ts8Gud4LpjopVy5cILKh6DWFDEJhyMC+rvVu4DZSzwUO7Ovj8XDWIZIOCPjT5vWtjxsa5dvtDdOmRvvROH/6EDxYDxS8M2490DCPm5/2v0+wwA0VzNNtWGR5XYm32fn8i/M8S9/TewEAAAAAADiHd29ub/Ph24wF3tUssEijD5as0EootFhydMk+89nHZ5R7FuPLODVwEpzKOC/Obow4FXASnMqoSapN2DG4LypSbLFG3B8ttFij40p3xP1RrZTX5la/8LAfO3ujtXT90B526Zo1BCX8sIA/GDfoXwodNG5vAuP4xZ4InHmUVt44t6G/v5w/btoHO8024ne2qxud7clAax2Vc55fph4I5vb087a0bqbheR4/sJAMFTgBAvvw+4X2+kVaChi0nyzIp9n9Dg+aOz7X+0AjjRhjpO976bpOlMxpIhlfwkBAGEYwRkTfdWaa/77v+3TIQOIwwXrQYLwwjR/McJrtrWFrUCE57ullnLrzq1GikePg0NWMW9/OxCBUEM2zFlyIJ2woS2IhAAAAAABO6oinm5finLtVw14F9yiPLvKX7uEu7VZdt5VDNZxjjsqKu9Xeu3Xmaz3KwmmGz+OsuzQOP76A0w7fw9l3GRzqwx31ZPNSnHS3RqXvXeKu4JFF/vJNyNyu1X1v1Cr9XAtUVtxn7bF7r94fTS1in3YftnX1QwyZjQWjtdZDm2IRubXt6geomdq3ZnooWHhv/23aZl7Dhl4KdBAkmLY/hQriIEG+l4PEPjjLai98MG/Da/Tv9C7Q6Li3g7Ztg3DCXNdT6W3vB0pneypw55urMR5fg6VwgcjG63bNvRiEUruS6tEg99r3/fTB9ZcVcYMGufd9b0SM8YIGcy8IwzxuI/6pFwKvHPF8W8IHa9O6LlWOLcNrgYNhuOu6TcECd0yjdT5EsBA0GFJb6TBBdtuSSXllggj0YAAAAADgasp6yvFpblW8h2qIUCUpF66VC+/6EqplybVqp6zf7d90reMOB4ceAU4JpHFmXAaHGhmcGtfzuaeab8VZOKEqkqiWHGqGKsijapZcp3bS90cX9j8xSU3fG5bbwaYXj9uv9t3YY4ENviWaeYdjpsb5YQ8Fzjjb6H6aGvVsEAxPT/cPeyDwp+fWMTXyD8IFuddGjz0HqFTPAXNPBWFwwI5r23Ycnpe3vRbYttp2nN2nMKQQvqaGp72uLEyQQsBggbtb3nBvEo36zRQs8IIHRqQ3fTKkEPZU0Pd9NG7tvVJqbsT/4msYMHjlteseTwQO0sNd1/nhAO9gzC9zqGBedp4lDBqYaPm+6xJbyKQEJP2H4dqFXETGniAAAACAa2uK+4+W+pzyD+6voCYPQbXuiurcE7W5G6ryELVUK9/l6lDL+YQUjt4pcVirxuE7A47iaVR0KMtrbF6nig55BajNw1HFu6NK90aNHoJqPUypVZvqwSBd1nisVjoz1Q8azEGBaNK8Lq2m9sk29OA17k629J5H2oBBGCpw3yiRuSeAYGb7fup5YJoe9yaQ6q3Aa/D/wrBS4/4bEVFD7whhrwSp5du2idYTLhP2PrAaKhAlSid6KjhBoMC1Fi4Q2RgwEDlvyMCKds8JBbjT117n3ggywYGN02zj/qERux9oyPVoEPVQ8PK8K/M4jfttrwRrjf+NDAGD3NVYjxfqrSGCtW1NvQtkLsjxRbyJy5ZecHpLDwaoxqmv3gCAEummlKeg8kvwFDiMX0G1fxO1Xy0O3VdR/d/GEajOdF/2G9/dOV+qxGH7CKr5G6j14nGIPorqXldGQ3OO1KlwOL+K6i8BR6F6HMIicBhKwZGozdyDQT5lELY7jf4mWAwoGGc78UqV1mMbZTM88V8k0apbxaODeZqF+7w2NDAtlgwS+OGB3HAcKvDDAlFPA16PA8vz5tbprqNpmmwPA374YDlIkJsW9VSgnJ4gTmRLuEDkiYCByPlDBlYYGrDDW0MG7mvXdU6D/edCBmJEurER+9TYXyQRerDrH+d5JliwZZ7N4YN5mu1FIKpb598oHJAaZ9yp24MHc+8C/imbvOGzeIHPj6UHAwAAtuGJmGW5xBf66nGU8AROl2pwqGrC0cIKTpGqcLiW8fca58g6auhrqPpFVM9W1NTR3CdW4ns402vDEcMLOG2qwuGqFUcOG3CaVItDl+beHw3bqeZ7KEiPyY1OPXxbKT21A25WehUIwwHTtPH9UhP4uMeCbb0TpIbXQgW51yhsEIQOtNJ+6CEKJAwBir43opTTW8OGUIHW2tkXWy5/fvf9XDVnjBXMDgkYiFwnZGCFu2vfb+3ZwO2BoO/7OEQwDYvYEIIbOvCXkWldU7nGeWsKHUSBAWcwOe2F6W7AQW/qxmbbBd99mwtRAADW7fuExEt9NcEZcMqeBofyLDiSqACn6SlxWM+CI4mCbTg9l/8+5/x+20mr8KS7NTr33h3m5NV28t2TK+zhrnKNRa6O0+h0OKRnxtFFJThVT43DexUcaRQm+fec07PA2N5VazW0xzXpB1rnz+z0lKn3AjM3ZO/6fgwWiEQ9FCS6KlibpptmU1jAbWQfDU/Lz8NaN0FoIG78v/W10c1cJjvNKZsfHHACAmo4HrnpuWVy24l7PvADBme3NVwg8kLAQOR6IQMr7NFg7XVt2hQecAIF4XydbZQfBAr8+aYJ07RwuS0hgqXwwFPBgsw02xuD3Q/nxRtp6ySekn6XmuRtSxJdzCysbmv4gB4MgH3xxLw6XfILwWVxtIHN+LhcAof5qjjywCI+IpfAYT6Xb9+PKfd8Krdkhyp0twst1ihfOp5qXo+yzzEchyMPvISPzqVx+DHgTACy+HjAwelQh0br6SHatt113/fJYMFkWzNUfztjmKDv+kRIXSWG5hFhe3Ct/R4R3Cf/24We7aVgKXgw9bCw1BtB0CuBUlqUiCidaMyf6VFgDjMM+2jbN4fBhGSAIHgN58kFCWx44iqeCReIvFEzVw0ZWKmwgeX2JuD1TGDnTQQK+q6PGv6LDEGB53ocyIcHbKP7l0IHS9M2BhK6LhcwSLfwz02zY4zJNfDfclqvpgpWJ9GDAbA/nvJTmUt/E4CLUwE+zgigaHxEkcGpgXWcJcBXHfQRLPpezIGXnWOvaBVcL6ut289s4S1B8Yr+jKH40wmfxymBZZwhQJX46GIFpwiewxkDFOmNj6YeG8+LiPR9NzRyX1rgpRbXSozpk0/JH8Y934OBmh5sYeYy54IDG6fNDfnV1PB+a+8FbiDD30a6Z4LUa9M0XhjArmsOKYwhh0xvBeE6lVJRWaa1XidTMHk2XCDyZvTi6iEDKwwb5Ho6SIYAUmED27NBuI1pXhGRTHgh95pYtuse4/Rh3PagwWvzD0/8d/bLSVHFL8vj7FqGC5Px1mUDHjnGbDzxL3gRAbK42uPkOMVxXZz9AFAlLt+4AE5zYMl+n5DFJ3EBZ8cvG1wMpzwQ4lMBAKfE5R0XwykPvGL+5Gitpe+NaL3QWHTlg2ZEFhusx/dgMz0WZNehgvL5MzZaZ0MD+Z4NhoF52USIINPTgL9P8zStddCTQRwISA3b3gqUUtNrrpcCf9ywfluWVKBgalOvpr2/pFfCBSI7NKEmZODLhQtWX6MAgP/U/2xAQcQLDWit5ob8YS8CuVdnXfP2xF9Hdtz2IMLQS8M4bqokWR/nvEyBgmm+MHQw/OuFDBJnaDxq/TS2XctE6wcAAAAAAADepHZp6F3Rrdqdi7rv6iqpxx2Kuc95h+uo5LMBAFfCpRkF4/REGTgTAeBrVi7B+96Xqux6X/S90WPWeJg3i7p8Hr648nExpdTUvvXVkEH+ATFzzwZuD5pRA/tEjwX6yVBBKkzgLuMup3UThQpSQQP7apfb0stBqhypHhS8GrpiVwWBV8MFIjs9o52QQVoqbGCHnwkf9H3vNaa3jduXekqwaZ5hZNzoP1xHKqwgYuLAgbvdlfBBOL3vu22BAmdcNlAQlOmZgEH6ZN12CuuxaxkTbgMAAAAAAGBH+z5VnFt3bymg+goowqicklSlkGpLFYMeDF5RyAEFgFpxGcUTOF2wD84kANjky5fLYx6CwO+AtxVShYUUQ0oqSZUKqj5blPj+6JOFTMyutIras6bvw6rsO6V10NtAPKedNAcMEr0XjO/TIQGnob4TRJh6BAjDCc7w0MPAPM9SMGAKGATzuj0PuMPuazg+NY83LghYXN074QKRHauSkMGyZ8IG7nAqYBDOHwUOkvOOExLz20BCOL8xfTKA0PddYjvz+nNhg85bbp7fHbcUKNgaMIga/ifOzHiUPyZ5QTf+nAQMAAAAAACf9FwjUG7TnFaFh7bCIjvqLj0SKj2kRxX7+IBBpRUOAFtwibsMDvXVcMQBVOpkl6/nG5ufrAIQq/gQV1x0qb30WFD5od2r+PP90Y1rdGZTWiWnOS1cn7j/ahvUq+n9UsDAnTZsIzd/KmTgN87XWnsN87cMiyhpmnm5pd4J0r0QpMfnggSp4bkkQk8FCe+GC0QIGHzFlrCBOy3f20AQTHAa8ad6HFgKIITj+t5Ey+eWm4IDwXbDQIDtDWGe5szrjNPOhXepl4KlwMFayCAVMFi8mJt4kIABAAAAgG/T4Y0rYG8XuNtzgV0cXWdPUZCLnHY17ybfJQBsVvPF7uQ4NKXjCAE4wMUuLVHjPeBIF/p8XWhX5Wp7i8Jc8PSraZdX748m2o2677TS2WnzNtZDBvE864GBedlGwlmH70+peePeCdaG3QDCth4L0j0QLM079Ijgtxu2xyYVOgjLCt8e4QKRnauXkMHz8mGDoQeB1LzufGvhA9uofylwkOpx4JVpQ0BiGJdqfN91vUQXT6XzvRKE7zcGDJIN/zMBA6/HhJzkL4nMdgAAAIAvOv4JtMCbuGswoSpC1AiwiI9IhCpJeb5W+P4IvIiL0K6oziNQq8BlXPDjTmNzVOWCn9ElVEcKtQI8jY9NEtWyJF872fujxnuJ1rElWLC6DRFRSm8OEuRCB41upna1YbvyqXcDp+cBFQQIouFEg36tG1EbAgZaaa+XA7c4NkSQ69Egte24nby/TsT2CheIHJDfIGTwurDq3CBAtteClfninglsIGGcmFjn3mGEvu+j8ISfNnIa6ochgmAflueZxy31YBCeoFtTaOEvCwIGAACgBjQYwinwV+ZTqK5nUWPAafHxfgnV9o76ao+/F/Ax9X08DkNVhKgR4KNO9pGjoTlO52Sf0U+gyp5FjQGXxcf/LVTfs+qpsej+qNdWNN4PpcL7qev76m1jnH3+WyZsMB+HCOIn9ed6NxgDC1FQIBMqsA39nXFN03jj5ml2HSpav7t/brvgrb0XpIIEuV4LsGzPcIHIQR1EEDJ4Xy5AsO1VJB8QmK+AXd9Nw9mwQGpcYv6tgYO+672G+mGPBfO63hufavwfp8Y2nKYLSTQCBgCAGtF4BKfCXx27oBr3RG0CqASXq7dRhUeidj+JvxErdLKPyMl2R864R0DWCU/3E+6SnHWvXKf9PnP+Q/cxVOVRqFkAleMythuq8lOo6SOEjf9z7VOV1vH4Z9Y/rjv9MOzcU/lzQQL75P+hPG6oYHifbpy/ddgNBqRf3e3FvSOsLp/oBSHVLp5gwXP2DheIHBQwECFksLdczwVrYYP0NJEwPBD3MrAeIHglmND1vSQvtImLszEmOX5tObfhv3uBDtaeXl+w7qVlCBgAOIvT3nzHefEt83BU8adQ0wBwGC6xH0eVfws1j/dwT2BFoR+xQoslJZcMFXvxtOKp5qgOl9DDUcWfRo0DQJG4PH8E1fxtHAFsEzb+986dxUDAk9tReu4FwI7MrnYOFaTai8cP2R7K6PdyoPKBA2c+rXW6l4MgEGCHvZ4Kgl4Vwp4I1nosmMuuxRgjSqnpFc87IlwgcmDAwCJosK9UddqgwTMhgzAcEDaWH9Y3zugt/9643vaaMG1oLsf28SLGPNG4/4BwgQgBAwDnUlyDAr49fAxV/U3UPgBgB/w6+SiquyQcDWAPxd0PyPnAR/4zVxWuXdX60KH73BlyjXPxq9e4a1RxUajyUnAkAAAfxq+er6DaS8bRAbbSWsfhgrHd6l73FNbW47cLz/VYsLyeqceAN0MGS2GDefvxepXyAw5roYJcWfCao8IFIh86NIQM9pcKD7jDm3ogCOZzQwrDuHFBETG9WVx+bf12+tQoPwwQJN/P2w/LY99rrfx9zQUTshJdq0xFWF7PlQIG1fxHI8rBVf8rqPaScDQAANiMX5tfQ9XXgKME4Fi73vd745L1+qLPL8lTsODhV20xOBSl4EgAALA7fr1WgcNUAo4CgM/6bJtIv2H+OCZqvhqOi8sYhxC8ngWCjSwHBJwgwdBlQtRjQxhGcE3BhkR4YG2cKEWu4E1HBgumbRy9ARdBg2OE1Rq+tw3h10IJucb/yUCCFzgYF4qGM9tYCxck92leb/je/ZzY8aYP4wnOxrYIZ8t8Uq50SvMfb3jJdT4iwFP4aAA5fDoAAACAT9p8z297p7C7zHU07nXiLWWcxkAV+LgAn8AnDQAAAHiFUsPDraN7hRvbjq6sXZQKegVYXdc8T6o3geTcKm74HwcXhnVopedeBmTsVWDqdUAH2wm3O4cPou2lAgSS6LlgGJneGTzlE+ECkS90LkHI4FhLvRksDYsR6U2/ad6lHhDW5u/7/qnwgC2bSYQJckGIzT0LGO9Fnrn5opSaQgwAAAAAAAD4DqW5Gb1He6L97nJxv6woGw4HnyEAwGb8mq8Gh+pMOJoAAMDHQxMcO31V4t7oyS0clqPujSqlvLat6Z4S1Pyv92B/nQki5IIGSrT2wwFKqXTvCGGD/+m9ipZ3NU2TnRaGC+JrVD4gged9Klgwbe+TG7MIGXxGNkwgcSBAxO3pQGRrjwSp4dS67bqGbczT/N4H8r0axCGE/LxewOCNEEG4SPgLZXOQAQAAAAAAPC264frBu0mfvXHFbTJU4sOn6uc/Gdf8LG7qBvyaVfMVVPWnUNMAAKByfJ0pBofiU85f09m/z097T/Q7WwTe8oVT9jufkut8Nqdrb7DL6RqIx2qlV9ulKjVsY633gtTvgVRIINVgP7ns2CNBGCgIl8lNT82bmy9q867Udxqmn9ynwwUiXwoYWAQNPmepN4NXey1wG/YvBRHS4YZh/qiLmdVgQfg+HTR4qfF/IozgXRzNtIfxtgEAAAAAm/GEHVSrsFsBhRVnVGapAKTxOxkAKsDXq1VU0auoOQA4Gn9z4VQK/OpQYJGk1FIBiL39e9pkekFw2qHqxV4S/F4MbCggVT4/bBD3OGDbsroN/lOBAbc97JZwwVLowN3mOECw4CDfCBeIfDlgIELI4BtSDf7D8UeFD6aG/0GQIJwvV9Yty62GC7wgQSJZpnUUJkihBwMAAAAgtukpuN9WyV+hlRRzVFdpAeAtlV3yKiuuo96S16SK727PutCpc6FdHV1vjwEAF3HhX3E17vpyI7GCVFS5FRVVaistAByi0kthpcWWmkteuvDh086LrNX7M+29l+7BDuuJeyVI9V4QbtPOE/YiEM2X6XFga6hg67qxv28FC6btf3PjLoIGn5eq8u1hA5H5Sf7bh3ON8udtzMvME+NQQXKcs7zpw3jAPLTUK8Ei46+PUxYAAFwNfxwCuJSK/+SruOiB8+wJAJSK7/gAqlDh18IKixyofw+AZ/G9CMClneRX/0l2w3G+PQKAkmz6GyB4mPWzD2zJbSPsrWAcmxi31JPBINcrgX2/Gihw1jnNmxi3Vk7s69vhApGCAgYihAxKkOuZwH2f6qUgbPCfW89SDwZryybDB4lpW3oWWP3s0YMBAABAklb7PuH0fH8AnG+PAAAozgV+3Z5vF8+3R2dxyh4MXlHIKVpIMaSkkgDAbgq7tBVWnFGZpfqkPe99nrc2z7tnAABU72S/pk+2OyuutbelmO6NJtqK7tm2227HmKXesPxG+6mgwNCWVolWfsgg1wtCLniwpUeC1P4X0N79EkoIFljFFMRF0OC7ctW/3qvBejghapS/0hNBrgyLp0hwwbfzZj93L/ViQA8GAOpQ0HcOAABwoT8hzrmr59wrAMC1cd8AeNHBXw2P/+ZZ93dbrl0AABSs7q8ZTzv37p577wAASN5fcNqz7vVwlqVG+/H4fO8A6V4P4nK6vRaktpGaniufGiakC4TdlRQuECk0YCBCyKAUuaBAbtxayGD4EQn/EFlb7/B+Xm5OZPnrDpff/Hl7JmQwogcDfBtPmAM2uMC3iXPv4rn3DgAAABl8DTx5FZx772pzqvtLL55a752RnM8o2Bun5/tn9vGfjVNdv7Y68SXnxLuWcb09BgAAwMFO/hXz5Lv3ImrlXXPPAn5d5tucqrHB/Wvbi9ebDhOkwgFL4YQwwKBERWXMhRy2lgnHKi1YYBVZKBdBg7I8EzhITXMb5a+ta+29/UzlggxL9jitODVRgkJ/twAAgDO68Nff8+76efcMAABsw72lAyx3vvv6whfBOQkAAIp28q9rJ989ucIeAgCA7eb2pyIiTzzMOrOetWmphv/evMH0Ydn1EIIblAh7Klgb3lIuHKvUcIFIRacFQYPyvBs2CKeFvRJs3o7TLY21uXeBF3ouAIBL4jIJ4OS4zAE4N65yAIC0gv/vAgDqxldwAHgbl1IA2ANXUwDIef/e6NCjgdLOehJtWbXSqy213Ub+Sqk4bJAMHwTrWOmdwA87iNBVwXeVHCywii9giKBBmbYEA8JxzwQU1seJuF+KNwcMvJX4YQOtdHSxXysHAAAAAAAoXwX37I714i2N9+6EcB8FKNHlr4dAbU726/RkuyNn3CMAAADUj7/9HdwXBeB45/q4uKxxP/lm6mFgbX1LvQwsjVvqgeCZHhTwGTUEC6xqChoiaFC2XDAgDAJsXW7bOH/dcw8Jy9sUWb7g55bnFAQAAABwVRXd9wDydv6zfv+7BNx3AHA8fqcDQMEq+zpYdnHLLh0AoEz8vYTTKv6+6HFrBQDXu7/rty6/NF8qfJAKAuTWsR5KGNaI76spWGBVV+AQQYPyLfVa4M8Ydw+Tmz+7HmcdyXkS27C2fH7dsAGnHgAAAF5R4d+NAFCnD/zZftwmuOcA4DP4bgoAqFIBX5c/W4QCdhh4At8xAaAAH/r6wP1RADXbIyDwzLLherb0PLC27WSoYJjwVDlxnBqDBVa1BQ8RNKjHlnDA0rQth7rv+2n42eDAJmN5OO0AAADwior/hgQAfMOBtx++d2eDeypACfheCgC4rJ2+ju75rZZfywAAAPLV24bHbpr7oUBplu6N7nnf1PZSYIzJ9DKwXo6lHgxy68V3etDa4QAABItJREFU1RwssKrfgRBBg7osHa61Q7m1Z4RNF9ClcMMCN8gAALXQKu5eawl/RAMAAADAqJA/Yfg7DXtx7xE8d+Q5TwCUQ234705+dwIAAADAwQ7+06isv7zKKg1eo5X22oxuaw+u3gqHLwUFtsy3dTq+5wzBAus0OxIiaFCvZ4IFW6YfeSqYntPsapQ+7WUTV1HdH3RcZwEAAAAAF/WBP4mru9eVqJOFR88cWBAAX5X4eO/xf7fHXDW4FgEAAAAA8FWZP82VVlHb0j3uL2wNEWzdnhJ14pbe53GmYIF1uh0KETSo35ZDuHeoYF5+/oh4HxaVmhcAAAAAAAAA6vGx//P40C3Uz2yG+8EAAAAAAABA7bx7oyY1aOL53OVFeT0gbNrOxmknbKt+WmcMFlin3bEQQYNzebeXA39ekWf+U8heDzilAAAAAAAAAAAAAAAAAAAAzu2VduSbeig4b/v0UztzsMA6/Q6GCBpcxzMhhKXP+tJ6OJ0AAADO4QJ/+wEAAJRj5ZbaPnfcuG+3Bd+DAQAAAAAAgC/5yH3Sfdd0Jkc3/h+WNWKbmHIv9hyuECywLrOjKYQNzu/oQ8wpBODKLvR9CQDwTW985U4vynd4AAAAi7/tAXieatjA31YAUAu+81Us8+uW+54AAADvO/57shK+ip/DlUIFrkvudIigASxOBQAAAAAAAAAAAAAAAAAAAFhDE3OaXF/FVUMFrstXQIiwAZ7FKQMAAAAAAACgRkop7m8CAAAAAAAAuBzajyNEqMBHZSwgbAAAAAAAAAAAAAAAAAAAAAAA50KoII+K2YiwAQAAAAAAAAAAAAAAAAAAAADUi2DBOiroBYQNAAAAAAAAAAAAAAAAAAAAAKB8hAqeQ2W9gaABAAAAAAAAAAAAAAAAAAAAAJSFUMHrqLidEDYAAAAAAAAAAAAAAAAAAAAAgO8gVLAPKvEAhA0AAAAAAAAAAAAAAAAAAAAA4FiECvZHhR6MsAEAAAAAAAAAAAAAAAAAAAAA7IdgwXGo2A8ibAAAAAAAAAAAAAAAAAAAAAAAzyFQ8DlU9JcROgAAAAAAAAAAAAAAAAAAAACAGYGC76HiC0PgAAAAAAAAAAAAAAAAAAAAAMCVECgoBweicAQOAAAAAAAAAAAAAAAAAAAAAJwFYYKycXAqQ+AAAAAAAAAAAAAAAAAAAAAAQC0IFNSFg3UChA4AAAAAAAAAAAAAAAAAAAAAlIBAQd04eCdE4AAAAAAAAAAAAAAAAAAAAADA0QgTnA8H9AIIHAAAAAAAAAAAAAAAAAAAAAB4F4GC8+MAXxjBAwAAAAAAAAAAAAAAAAAAAAAphAmuiYOOJMIHAAAAAAAAAAAAAAAAAAAAwHkRIEAKJwVeQgABAAAAAAAAAAAAAAAAAAAAKBshAjyLEwa7I3wAAAAAAAAAAAAAAAAAAAAAHI8AAfbGCYWPI4AAAAAAAAAAAAAAAAAAAAAAbEOIAJ/EyYZiEUQAAAAAAAAAAAAAAAAAAADAGREaQKk4MXFJhBcAAAAAAAAAAAAAAAAAAACwhBAAruj/A1+ErfJiT47SAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M529.81,505.71c-.4,0-.8,0-1.2-.01-1.1-.03-1.98-.94-1.95-2.04.02-1.1.93-1.87,2.04-1.95,14.41.27,22.48-5.62,30.31-11.36,6.51-4.77,12.66-9.28,21.69-9.85,7.28-.51,11.62,2.9,15.11,5.61,2.76,2.14,4.41,3.33,6.47,2.92,3.09-.62,3.27-3.39,2.52-9.79-.5-4.31-1.13-9.67,3.57-10.39,4.28-.66,6.5,3.43,8.63,7.39,2.44,4.51,4.43,7.72,7.83,7.72.05,0,.09,0,.14,0,.99-.02,1.36-.32,1.55-.54,1.09-1.25.68-4.94.34-7.91-.51-4.55-1.15-10.22,3.71-10.88,4.66-.65,7.01,4.69,9.28,9.85,1.66,3.77,3.73,8.47,6.06,8.53.39,0,.5-.11.57-.17,1.06-1.05.99-5.25.94-8.32-.09-5.24-.19-11.19,4.55-11.33.05,0,.1,0,.15,0,4.68,0,7.01,6.57,9.07,12.38.6,1.68,1.43,4.02,2.1,5.3.67-1.47,1.45-4.25,2.02-6.25,1.86-6.61,3.63-12.86,7.9-12.86h.03c4.15.03,4.54,5.27,4.95,10.82.29,3.87.72,9.73,2.72,9.78,2.12.04,3.69-5.07,4.87-8.81,1.67-5.29,3.54-11.29,8.42-10.31,4.74.94,5.3,6.57,5.8,11.54.32,3.17.71,7.11,2.19,7.74,1.32.58,2.97-.83,5.53-3.2,2.94-2.72,6.6-6.12,11.45-5.5,4.14.52,6.28,2.17,8.54,3.93,4.83,3.75,11.47,8.9,47.1,7.28,1.16-.15,2.04.8,2.09,1.91.05,1.1-.8,2.03-1.91,2.08-37.13,1.67-44.41-3.99-49.73-8.12-2.05-1.59-3.53-2.73-6.58-3.12-2.98-.37-5.67,2.08-8.23,4.47-2.82,2.62-6.02,5.58-9.83,3.94-3.64-1.57-4.12-6.37-4.59-11.02-.36-3.59-.77-7.65-2.6-8.02-1.34-.24-2.89,4.66-3.82,7.59-1.74,5.5-3.74,11.71-8.78,11.6-5.62-.14-6.17-7.54-6.61-13.48-.17-2.3-.45-6.07-1.1-7.06-1.37.78-3.1,6.9-3.94,9.89-1.67,5.94-2.78,9.87-5.79,9.87h-.05c-2.83-.04-4.12-3.65-5.89-8.66-1.21-3.4-3.45-9.71-5.31-9.71h-.02c-.79.63-.71,4.95-.67,7.27.08,4.61.15,8.97-2.12,11.23-.91.91-2.1,1.35-3.49,1.33-4.87-.12-7.28-5.61-9.62-10.91-1.52-3.44-3.45-7.64-5.09-7.5-.99.13-.54,4.1-.27,6.47.46,4.13.94,8.4-1.3,10.98-1.06,1.22-2.56,1.86-4.46,1.91-6.19.11-9.19-5.37-11.59-9.82-1.82-3.36-3.1-5.54-4.51-5.33-.89.14-.48,3.65-.21,5.98.59,5.07,1.49,12.73-5.7,14.17-3.95.79-6.88-1.48-9.71-3.68-3.26-2.54-6.64-5.16-12.41-4.79-7.86.5-13.29,4.49-19.58,9.09-7.78,5.7-16.57,12.14-31.56,12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M520.19,508.64c-.43,0-.87,0-1.31-.02-1.1-.03-1.97-.96-1.94-2.06.03-1.1,1.01-1.99,2.06-1.94,15.42.5,24.15-7.9,32.6-15.98,7.03-6.72,13.67-13.07,23.48-13.89,7.96-.72,12.67,4.09,16.44,7.91,2.96,3,4.73,4.65,6.8,4.12,3.87-1.01,3.65-7.02,2.95-14.77-.59-6.54-1.14-12.71,3.64-13.66,4.73-.94,6.97,4.44,9.33,10.15,2.16,5.21,4.6,11.11,8.51,11.11.04,0,.09,0,.13,0,.85-.03,1.23-.33,1.46-.59,1.65-1.86,1.15-7.63.75-12.27-.6-6.94-1.16-13.48,3.8-14.36,5.12-.94,7.49,6.12,9.99,13.54,1.74,5.17,4.13,12.25,6.63,12.33.24.04.32-.04.43-.15,1.49-1.47,1.41-7.93,1.35-12.65-.1-8.01-.19-14.93,4.74-15.12,5.17-.14,7.45,8.16,9.86,17.03.71,2.59,1.61,5.9,2.37,7.75.78-2.16,1.66-6.24,2.3-9.17,2.04-9.46,3.81-17.64,8.4-17.64h.04c4.36.04,4.72,6.43,5.18,14.52.28,5.04.82,14.42,3.1,14.49.01,0,.02,0,.03,0,2.22,0,4.16-8.04,5.33-12.85,1.54-6.35,2.87-11.84,5.83-13.61.99-.59,2.1-.75,3.22-.46,4.93,1.28,5.46,8.22,6.02,15.55.34,4.47.81,10.59,2.64,11.62,1.19.65,3.08-1.53,5.63-4.71,3.26-4.09,7.33-9.17,12.88-7.52,2.53.75,4.4,2.52,6.57,4.56,5.81,5.48,15.54,14.65,51.82,16.05,1.1.04,1.96.97,1.92,2.07-.04,1.1-.99,2.03-2.07,1.92-37.78-1.45-48.19-11.27-54.41-17.14-1.94-1.83-3.34-3.15-4.96-3.64-2.77-.82-5.31,2.05-8.61,6.18-3.03,3.79-6.46,8.09-10.71,5.7-3.7-2.08-4.17-8.26-4.67-14.8-.37-4.82-.88-11.43-3.04-11.99-1.69.93-3.12,6.84-4.16,11.15-1.98,8.18-3.85,15.9-9.19,15.9-.06,0-.12,0-.18,0-5.94-.19-6.46-9.38-6.97-18.27-.21-3.71-.52-9.19-1.39-10.63-1.51,1.32-3.33,9.76-4.33,14.37-1.87,8.64-2.9,13.42-6.12,13.42h-.06c-3.05-.05-4.19-4.23-6.25-11.8-1.05-3.86-3.83-14.08-5.83-14.08h-.02c-1.03.85-.95,7.26-.9,11.08.09,6.63.17,12.89-2.55,15.55-.91.89-2.08,1.31-3.36,1.3-5.27-.17-7.71-7.39-10.29-15.05-1.32-3.91-3.73-11.08-5.51-10.89-1.35.24-.78,6.89-.51,10.08.51,5.96,1.04,12.13-1.74,15.27-1.07,1.21-2.57,1.88-4.32,1.94-6.77.14-9.92-7.43-12.47-13.58-1.41-3.4-3.35-8.14-4.85-7.76-1.26.25-.73,6.2-.44,9.39.68,7.59,1.53,17.04-5.92,18.99-4.41,1.14-7.59-2.07-10.66-5.18-3.52-3.56-7.12-7.2-13.26-6.74-8.41.71-14.55,6.58-21.05,12.8-8.4,8.03-17.89,17.11-34.16,17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M524.93,362.33c4.02,6.3,6.17,13.77,6.17,21.43v34.67c0,7.66-2.15,15.13-6.17,21.43l-6,9.4v-96.32l6,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M524.93,362.33c4.02,6.3,6.17,13.77,6.17,21.43v34.67c0,7.66-2.15,15.13-6.17,21.43l-6,9.4v-96.32l6,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M521.18,343.85h0v114.5h0c-3.04,0-5.5-2.47-5.5-5.5v-103.5c0-3.04,2.47-5.5,5.5-5.5Z",
    transform: "translate(1036.86 802.19) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M458.8,315.09l4.39-6.29h48.83l4.39,6.29c1.64,2.35,2.54,5.28,2.54,8.3v155.42c0,3.01-.89,5.94-2.54,8.3l-4.39,6.29h-48.83l-4.39-6.29c-1.64-2.35-2.54-5.28-2.54-8.3v-155.42c0-3.02.89-5.94,2.54-8.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 463.19,
    y: 308.8,
    width: 48.83,
    height: 184.59,
    transform: "translate(975.2 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 463.19,
    y: 492.08,
    width: 5.86,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 463.19,
    y: 489.31,
    width: 5.86,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 463.19,
    y: 486,
    width: 5.86,
    height: 1.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 463.19,
    y: 481.97,
    width: 5.86,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 463.19,
    y: 477.26,
    width: 5.86,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 463.19,
    y: 472.09,
    width: 5.86,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 463.19,
    y: 466.3,
    width: 5.86,
    height: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 463.19,
    y: 460.14,
    width: 5.86,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 463.19,
    y: 453.37,
    width: 5.86,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 463.19,
    y: 446.29,
    width: 5.86,
    height: 4.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 463.19,
    y: 438.78,
    width: 5.86,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 463.19,
    y: 430.98,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 463.19,
    y: 422.97,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 463.19,
    y: 414.74,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 463.19,
    y: 406.52,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 463.19,
    y: 308.8,
    width: 5.86,
    height: 1.31,
    transform: "translate(932.23 618.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 463.19,
    y: 311.18,
    width: 5.86,
    height: 1.71,
    transform: "translate(932.23 624.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 463.19,
    y: 314.23,
    width: 5.86,
    height: 1.96,
    transform: "translate(932.23 630.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 463.19,
    y: 317.85,
    width: 5.86,
    height: 2.38,
    transform: "translate(932.23 638.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 463.19,
    y: 322.14,
    width: 5.86,
    height: 2.79,
    transform: "translate(932.23 647.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 463.19,
    y: 327.05,
    width: 5.86,
    height: 3.05,
    transform: "translate(932.23 657.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 463.19,
    y: 332.43,
    width: 5.86,
    height: 3.46,
    transform: "translate(932.23 668.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 463.19,
    y: 338.38,
    width: 5.86,
    height: 3.67,
    transform: "translate(932.23 680.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 463.19,
    y: 344.94,
    width: 5.86,
    height: 3.88,
    transform: "translate(932.23 693.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 463.19,
    y: 351.72,
    width: 5.86,
    height: 4.19,
    transform: "translate(932.23 707.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 463.19,
    y: 359.07,
    width: 5.86,
    height: 4.34,
    transform: "translate(932.23 722.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 463.19,
    y: 366.58,
    width: 5.86,
    height: 4.63,
    transform: "translate(932.23 737.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 463.19,
    y: 374.6,
    width: 5.86,
    height: 4.63,
    transform: "translate(932.23 753.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 463.19,
    y: 382.61,
    width: 5.86,
    height: 4.83,
    transform: "translate(932.23 770.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 463.19,
    y: 390.84,
    width: 5.86,
    height: 4.83,
    transform: "translate(932.23 786.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 463.19,
    y: 398.72,
    width: 5.86,
    height: 4.76,
    transform: "translate(932.23 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 506.16,
    y: 492.08,
    width: 5.86,
    height: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 506.16,
    y: 489.31,
    width: 5.86,
    height: 1.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 506.16,
    y: 486,
    width: 5.86,
    height: 1.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 506.16,
    y: 481.97,
    width: 5.86,
    height: 2.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 506.16,
    y: 477.26,
    width: 5.86,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 506.16,
    y: 472.09,
    width: 5.86,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 506.16,
    y: 466.3,
    width: 5.86,
    height: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 506.16,
    y: 460.14,
    width: 5.86,
    height: 3.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 506.16,
    y: 453.37,
    width: 5.86,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 506.16,
    y: 446.29,
    width: 5.86,
    height: 4.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 506.16,
    y: 438.78,
    width: 5.86,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 506.16,
    y: 430.98,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 506.16,
    y: 422.97,
    width: 5.86,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 506.16,
    y: 414.74,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 506.16,
    y: 406.52,
    width: 5.86,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 506.16,
    y: 308.8,
    width: 5.86,
    height: 1.31,
    transform: "translate(1018.17 618.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 506.16,
    y: 311.18,
    width: 5.86,
    height: 1.71,
    transform: "translate(1018.17 624.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 506.16,
    y: 314.23,
    width: 5.86,
    height: 1.96,
    transform: "translate(1018.17 630.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 506.16,
    y: 317.85,
    width: 5.86,
    height: 2.38,
    transform: "translate(1018.17 638.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 506.16,
    y: 322.14,
    width: 5.86,
    height: 2.79,
    transform: "translate(1018.17 647.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 506.16,
    y: 327.05,
    width: 5.86,
    height: 3.05,
    transform: "translate(1018.17 657.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 506.16,
    y: 332.43,
    width: 5.86,
    height: 3.46,
    transform: "translate(1018.17 668.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 506.16,
    y: 338.38,
    width: 5.86,
    height: 3.67,
    transform: "translate(1018.17 680.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 506.16,
    y: 344.94,
    width: 5.86,
    height: 3.88,
    transform: "translate(1018.17 693.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 506.16,
    y: 351.72,
    width: 5.86,
    height: 4.19,
    transform: "translate(1018.17 707.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 506.16,
    y: 359.07,
    width: 5.86,
    height: 4.34,
    transform: "translate(1018.17 722.49) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 506.16,
    y: 366.58,
    width: 5.86,
    height: 4.63,
    transform: "translate(1018.17 737.8) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 506.16,
    y: 374.6,
    width: 5.86,
    height: 4.63,
    transform: "translate(1018.17 753.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 506.16,
    y: 382.61,
    width: 5.86,
    height: 4.83,
    transform: "translate(1018.17 770.06) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 506.16,
    y: 390.84,
    width: 5.86,
    height: 4.83,
    transform: "translate(1018.17 786.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 506.16,
    y: 398.72,
    width: 5.86,
    height: 4.76,
    transform: "translate(1018.17 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 468.02,
    y: 308.8,
    width: 39.17,
    height: 184.59,
    transform: "translate(975.2 802.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M499.67,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M490.21,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M480.76,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M471.3,326.29l.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.11-.15.25-.24.39-.24h1.42l-1.7,2.35c-.28.39-.28,1.09,0,1.48l1.24,1.72h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-2.06,2.86,1.7,2.37.07-.12.69,1.17.13.18v.02s0,.02,0,.02l-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33h0s.82,1.39.82,1.39l-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l2.2,3.72-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-2.2,3.72c-.22.38-.22.97,0,1.34l1.38,2.33.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.38,2.33h0l.82,1.39-.82,1.39-1.38,2.33c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l1.8,3.05c.22.38.22.97,0,1.34l-1.8,3.05c-.22.38-.22.97,0,1.34l2.2,3.72-.02.04.02.03-.21.29-.61,1.03-.06-.1-1.71,2.38,1.77,2.46h0s.82,1.14.82,1.14l-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l2.06,2.86-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-2.06,2.86c-.28.39-.28,1.09,0,1.48l1.24,1.72.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.24,1.72h0l.82,1.14-.82,1.14-1.24,1.72c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.53,2.12c.28.39.28,1.09,0,1.48l-1.53,2.12c-.28.39-.28,1.09,0,1.48l1.7,2.36h-1.42c-.14,0-.28-.08-.39-.24l-1.24-1.73-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-2.06-2.86.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.31-1.82c.26-.36.28-1.01.04-1.41l-1.36-2.3-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39,2.2-3.72c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-2.2-3.72.82-1.39,1.38-2.33c.22-.38.22-.97,0-1.34l-1.38-2.33-.82-1.39.82-1.39,1.35-2.28c.24-.4.22-1.05-.04-1.41l-1.3-1.81-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14.82-1.14,1.24-1.72c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14,2.06-2.86c.28-.39.28-1.09,0-1.48l-1.24-1.72-.82-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M958.81,509.19l-27.97-22.56c-2.73-2.2-6.62-2.2-9.35,0l-27.97,22.56h-33.9c-6.33,0-11.46,5.13-11.46,11.46v11.69h147.25v-11.69c0-6.33-5.13-11.46-11.46-11.46h-25.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M932.92,513.27l19.11-20.59h-50.39l19.11,20.59c3.28,3.54,8.88,3.54,12.17,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "996.09 496.16 864.01 496.16 864.01 484.97 957.64 484.97 996.09 491.94 996.09 496.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 880.55,
    y: 484.97,
    width: 77.09,
    height: 11.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M932.91,506.37c0,3.36-2.72,6.08-6.08,6.08s-6.08-2.72-6.08-6.08,2.72-6.08,6.08-6.08,6.08,2.72,6.08,6.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 1302.62,
    y: 473.88,
    width: 1783.93,
    height: 92.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M767.11,457.44v32.86h372.22c31.92,0,63.73,3.82,94.74,11.38l116.64,28.43c29.5,7.19,59.75,10.82,90.11,10.82h1645.73v-83.49H767.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M723.03,518.59l-27.09-21.79h-307.63v-48.27c0-13.61-11.03-24.64-24.64-24.64H62.14v167.59h61.44c14.98,0,29.61,3,42.31,8.66,16.52,7.38,35.51,11.27,54.92,11.27h99.68c8.66,0,17.34-.82,25.76-2.37,7.53,6.08,15.39,10.05,23.09,10.05h166.1c13.48,0,23.04-3.25,34.11-7.01,13.11-4.46,81.45-7.26,81.45-7.26h253.64c4.84,0,9.69-1.17,13.69-3.89,3.73-2.53,8.13-3.88,12.63-3.88h256.42v-45.15c0-2.01-1.09-3.85-2.84-4.83h0c-33.67-18.68-98.95-28.49-137.46-28.49h-324.04ZM320.48,592.12h-99.68c-14.98,0-29.61-3-42.31-8.67-5.98-2.67-12.3-4.87-18.83-6.61h158.75c3.36,4.97,7.05,10.06,10.98,14.91-2.96.24-5.94.36-8.91.36ZM343.95,589.58c-3.45-3.87-6.88-8.18-10.22-12.73h50.23c-3.18.84-6.31,1.77-9.35,2.83l-19.12,6.66c-3.72,1.3-7.59,2.37-11.55,3.23ZM565.53,600.26c-10.84,3.68-18.68,6.35-30.09,6.35h-166.1c-2.12,0-4.37-.59-6.7-1.63,1.08-.34,2.17-.67,3.23-1.04l19.12-6.67c10.84-3.78,22.95-5.78,35.02-5.78h112.83l48.32,3.77c-5.91,1.7-10.98,3.42-15.62,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M388.31,481.12h0c-2.95,0-5.34-2.39-5.34-5.34v-178.18c0-2.95,2.39-5.34,5.34-5.34h0c2.95,0,5.34,2.39,5.34,5.34v178.18c0,2.95-2.39,5.34-5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M251.48,316.24c1.74-2.14,2.66-4.94,2.3-7.88l-2.46-19.75c-.71-5.71-5.96-9.8-11.67-9.09l-.34.04c-5.71.71-9.8,5.96-9.09,11.67l2.46,19.75c.37,2.96,1.98,5.47,4.22,7.12-4.18,2.64-7.24,7.01-8,12.25l-8.48,58.55c-1.38,9.51,5.27,18.41,14.78,19.79,9.51,1.38,18.41-5.27,19.79-14.78l8.48-58.55c1.24-8.54-4.01-16.58-11.99-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M87.88,356.38c-.2,1.92,1.18,3.66,3.04,4.16l23.56,6.41-2.76,10.14c-.38,1.39-1.81,2.21-3.2,1.83h0c-.95-.26-1.92.3-2.18,1.25l-14.33,52.66,21.4,5.82,14.33-52.66c.26-.95-.3-1.92-1.25-2.18h0c-1.39-.38-2.21-1.81-1.83-3.2l2.76-10.14,23.56,6.41c1.86.51,3.93-.3,4.73-2.05,1.02-2.24-.23-4.75-2.5-5.36l-60.46-16.45c-2.27-.62-4.61.92-4.87,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M125.5,259.98h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 274.8,
    y: 259.98,
    width: 63.55,
    height: 113.32,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M274.8,345.32v16.89c0,6.13,4.97,11.09,11.09,11.09h41.37c6.13,0,11.09-4.97,11.09-11.09v-16.89h-63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M138.01,356.95l-5.79,8.81c-3.08,4.7-8.33,7.53-13.95,7.53h-39.42c-1.09,8.59-1.8,17.08-2.14,25.56-.47,11.93,10.7,20.94,22.24,17.9l127.56-33.59c9.13-2.4,15.5-10.66,15.5-20.11v-17.75h-82.45c-8.69,0-16.79,4.37-21.56,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M369.19,526.98v108.78c0,15.1,1.6,18.96,6.78,30.3,3.46,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28-6.07-3.52-23.11-6.5-24.13-33.68-1.62-43.08.07-113.48-4.13-108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M414.27,448.39h-24.76v-33.44c0-4.01-3.25-7.26-7.26-7.26s-7.26,3.25-7.26,7.26v70.4c0,4.26,3.45,7.71,7.71,7.71h31.58c4.26,0,7.71-3.45,7.71-7.71v-29.25c0-4.26-3.45-7.71-7.71-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M399,478.27h24.76v33.44c0,4.01,3.25,7.26,7.26,7.26s7.26-3.25,7.26-7.26v-70.4c0-4.26-3.45-7.71-7.71-7.71h-31.58c-4.26,0-7.71,3.45-7.71,7.71v29.25c0,4.26,3.45,7.71,7.71,7.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-156",
    cx: 414.79,
    cy: 461.49,
    r: 34.46,
    transform: "translate(-177.25 647.28) rotate(-65.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-154",
    cx: 414.79,
    cy: 461.49,
    r: 27.78,
    transform: "translate(-130.5 757.61) rotate(-76.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-155",
    cx: 414.79,
    cy: 461.49,
    r: 21.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-157",
    cx: 414.79,
    cy: 461.49,
    r: 17.19,
    transform: "translate(-130.18 758.2) rotate(-76.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M399.44,285.6c0-4.55-3.69-8.23-8.23-8.23s-8.23,3.69-8.23,8.23v49.12h16.47v-49.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M264.18,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM264.18,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M356.47,626.8v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.23-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM264.18,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264.18,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM264.18,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M314.06,632.33c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.63-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,3-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-148",
    cx: 264.18,
    cy: 624.09,
    r: 31.07,
    transform: "translate(-408.21 708.81) rotate(-74.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M264.18,573.43c-27.98,0-50.66,22.68-50.66,50.66s22.68,50.66,50.66,50.66,50.66-22.68,50.66-50.66-22.68-50.66-50.66-50.66ZM264.18,671.7c-26.29,0-47.61-21.31-47.61-47.61s21.31-47.61,47.61-47.61,47.61,21.31,47.61,47.61-21.31,47.61-47.61,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M264.18,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM264.18,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M314.06,632.33c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.63-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,3-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M264.18,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM264.18,673.04c-27.04,0-48.95-21.92-48.95-48.95s21.92-48.95,48.95-48.95,48.95,21.92,48.95,48.95-21.92,48.95-48.95,48.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-145",
    cx: 264.18,
    cy: 624.09,
    r: 18.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "266.65 645.21 262.48 645.21 260.39 648.82 262.48 652.44 266.65 652.44 268.74 648.82 266.65 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M266.61,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "280.86 637.27 277.91 640.23 278.99 644.25 283.02 645.33 285.97 642.38 284.89 638.35 280.86 637.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M283.39,639.86c.8.8.8,2.09,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "285.3 621.62 285.3 625.79 288.91 627.87 292.52 625.79 292.52 621.62 288.91 619.53 285.3 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M288.91,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "277.36 607.41 280.31 610.36 284.34 609.28 285.42 605.25 282.47 602.3 278.44 603.38 277.36 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M279.94,604.88c.8-.8,2.09-.8,2.89,0s.8,2.09,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "261.7 602.97 265.87 602.97 267.96 599.36 265.87 595.74 261.7 595.74 259.62 599.36 261.7 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M261.74,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "247.49 610.91 250.44 607.96 249.36 603.93 245.33 602.85 242.38 605.8 243.46 609.83 247.49 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M244.96,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0,.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "243.05 626.56 243.05 622.39 239.44 620.31 235.83 622.39 235.83 626.56 239.44 628.65 243.05 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M239.44,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "250.99 640.77 248.04 637.82 244.01 638.9 242.93 642.93 245.88 645.88 249.91 644.8 250.99 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M248.41,643.3c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0,.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-144",
    cx: 264.18,
    cy: 624.09,
    r: 13.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M945.35,598.46l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-186",
    cx: 808.19,
    cy: 624.09,
    r: 39.87,
    transform: "translate(-121.77 202.38) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M1181.81,598.46l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-186",
    cx: 1044.65,
    cy: 624.09,
    r: 39.87,
    transform: "translate(-159.31 447.28) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 893.73,
    y: 549.91,
    width: 65.43,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 885.83,
    y: 555.7,
    width: 81.24,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 877.92,
    y: 561.5,
    width: 97.06,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 870.01,
    y: 567.3,
    width: 112.87,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 862.1,
    y: 573.1,
    width: 128.68,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 854.2,
    y: 578.9,
    width: 144.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 846.29,
    y: 584.69,
    width: 160.31,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 838.38,
    y: 590.49,
    width: 176.12,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 830.48,
    y: 596.29,
    width: 191.94,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 822.57,
    y: 602.09,
    width: 207.75,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 814.66,
    y: 607.88,
    width: 223.57,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 806.76,
    y: 613.68,
    width: 239.38,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 902.91,
    y: 548.65,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 942.78,
    y: 548.65,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M907.62,613.47l7.54,34.13c.42,1.9,1.44,3.14,2.58,3.14h17.42c1.14,0,2.16-1.25,2.58-3.14l7.54-34.13c.72-3.26-.62-6.8-2.58-6.8h-32.49c-1.96,0-3.3,3.54-2.58,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M907.74,632.92c-4.44.38-8.02,3.25-9.6,7.11l-100.9,8.57.88,10.35,100.9-8.57c2.21,3.53,6.23,5.77,10.66,5.39,6.31-.54,10.99-6.09,10.46-12.4-.54-6.31-6.09-10.99-12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M945.15,632.92c4.44.38,8.02,3.25,9.6,7.11l100.9,8.57-.88,10.35-100.9-8.57c-2.21,3.53-6.23,5.77-10.66,5.39-6.31-.54-10.99-6.09-10.46-12.4.54-6.31,6.09-10.99,12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M1188.55,670.56c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-45.37-.81-56.86h-3.32v57.23c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M923.5,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M917.26,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1160.28,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M1154.04,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-186",
    cx: 808.19,
    cy: 624.09,
    r: 39.87,
    transform: "translate(-121.77 202.38) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M807.95,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM807.95,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M900.24,626.8v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.86-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM807.95,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M807.95,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM807.95,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M807.95,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM807.95,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M807.95,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM807.95,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M807.92,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM775.15,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM767.11,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM786.42,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM807.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM808.05,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM829.42,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM840.68,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM848.73,634.27c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M857.95,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM782.79,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM807.79,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM843.95,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M772.74,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM807.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M807.92,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM775.15,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM767.11,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM786.42,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM807.79,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM808.05,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM829.42,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM840.68,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM848.73,634.27c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "810.42 645.21 806.25 645.21 804.16 648.82 806.25 652.44 810.42 652.44 812.51 648.82 810.42 645.21"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-181",
    cx: 808.34,
    cy: 648.82,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "824.63 637.27 821.68 640.23 822.76 644.25 826.79 645.33 829.74 642.38 828.66 638.35 824.63 637.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M827.16,639.86c.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "829.07 621.62 829.07 625.79 832.68 627.87 836.29 625.79 836.29 621.62 832.68 619.53 829.07 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M832.68,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "821.13 607.41 824.08 610.36 828.11 609.28 829.19 605.25 826.24 602.3 822.21 603.38 821.13 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M823.71,604.88c.8-.8,2.1-.8,2.89,0,.8.8.8,2.09,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "805.47 602.97 809.64 602.97 811.73 599.36 809.64 595.74 805.47 595.74 803.39 599.36 805.47 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M805.51,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "791.26 610.91 794.21 607.96 793.13 603.93 789.1 602.85 786.15 605.8 787.23 609.83 791.26 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M788.74,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "786.83 626.56 786.83 622.39 783.21 620.31 779.6 622.39 779.6 626.56 783.21 628.65 786.83 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M783.21,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "794.76 640.77 791.81 637.82 787.78 638.9 786.7 642.93 789.65 645.88 793.68 644.8 794.76 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M792.18,643.3c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-173",
    cx: 807.95,
    cy: 624.09,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-174",
    cx: 807.95,
    cy: 624.09,
    r: 13.18,
    transform: "translate(-204.66 754.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M1044.64,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1044.64,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1136.94,626.8v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.23,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.23,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.59,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1044.64,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1044.64,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1044.64,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M1044.64,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1044.64,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M1044.64,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1044.64,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M1044.61,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1011.84,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1003.8,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM1023.11,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM1044.48,577.91c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1044.74,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1066.11,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1077.38,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1085.42,634.27c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M1094.65,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM1019.48,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1044.48,588.71c-5.67,0-10.28-2.42-10.28-5.4s4.6-5.4,10.28-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1080.64,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M1009.44,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM1044.48,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1044.61,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1011.84,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1003.8,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM1023.11,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM1044.48,577.91c5.68,0,10.28,2.42,10.28,5.4s-4.6,5.4-10.28,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1044.74,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1066.11,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1077.38,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1085.42,634.27c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "1047.12 645.21 1042.95 645.21 1040.86 648.82 1042.95 652.44 1047.12 652.44 1049.2 648.82 1047.12 645.21"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-181",
    cx: 1045.03,
    cy: 648.82,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "1061.33 637.27 1058.38 640.23 1059.46 644.25 1063.49 645.33 1066.44 642.38 1065.36 638.35 1061.33 637.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M1063.85,639.86c.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "1065.76 621.62 1065.76 625.79 1069.38 627.87 1072.99 625.79 1072.99 621.62 1069.38 619.53 1065.76 621.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-181",
    cx: 1069.38,
    cy: 623.7,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "1057.83 607.41 1060.78 610.36 1064.81 609.28 1065.89 605.25 1062.94 602.3 1058.91 603.38 1057.83 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M1060.41,604.88c.8-.8,2.1-.8,2.89,0s.8,2.09,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "1042.17 602.97 1046.34 602.97 1048.43 599.36 1046.34 595.74 1042.17 595.74 1040.08 599.36 1042.17 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M1042.21,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "1027.96 610.91 1030.91 607.96 1029.83 603.93 1025.8 602.85 1022.85 605.8 1023.93 609.83 1027.96 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M1025.43,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0,.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "1023.52 626.56 1023.52 622.39 1019.91 620.31 1016.3 622.39 1016.3 626.56 1019.91 628.65 1023.52 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M1019.91,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "1031.46 640.77 1028.51 637.82 1024.48 638.9 1023.4 642.93 1026.35 645.88 1030.38 644.8 1031.46 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M1028.88,643.3c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.1-.8,2.89,0s.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 1044.64,
    cy: 624.09,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 1044.64,
    cy: 624.09,
    r: 13.18,
    transform: "translate(-159.31 447.27) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1149.99,571.72c5.24,10.56,8.91,22.04,10.71,34.12.32,2.15,2.12,3.77,4.29,3.77h14.06v-47.75h-23c-5.07,0-8.31,5.32-6.05,9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1178.11,587.56h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.71v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1178.76,
    y: 588.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1178.87,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1177.05,
    y: 588.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1177.16,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1175.34,
    y: 588.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1175.45,
    y: 589.28,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1178.11,565.13h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.71v-7.36c0-3.16,2.56-5.72,5.71-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 1178.76,
    y: 566.54,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1178.87,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 1177.05,
    y: 566.54,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1177.16,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 1175.34,
    y: 566.54,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1175.45,
    y: 566.85,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M428.59,518.59h246.72c2.96,0,5.36,2.4,5.36,5.36v127.75c0,2.96-2.4,5.36-5.36,5.36h-246.72c-2.96,0-5.36-2.4-5.36-5.36v-127.75c0-2.96,2.4-5.36,5.36-5.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 439.31,
    y: 640.12,
    width: 41.2,
    height: 25.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 453.82,
    y: 513.72,
    width: 12.19,
    height: 149.2,
    rx: 4.88,
    ry: 4.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M459.91,662.92h0c-2.15,0-3.9-1.75-3.9-3.9v-141.4c0-2.15,1.75-3.9,3.9-3.9h0c2.15,0,3.9,1.75,3.9,3.9v141.4c0,2.15-1.75,3.9-3.9,3.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 531.35,
    y: 640.12,
    width: 41.2,
    height: 25.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 545.85,
    y: 513.72,
    width: 12.19,
    height: 149.2,
    rx: 4.88,
    ry: 4.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M551.95,662.92h0c-2.15,0-3.9-1.75-3.9-3.9v-141.4c0-2.15,1.75-3.9,3.9-3.9h0c2.15,0,3.9,1.75,3.9,3.9v141.4c0,2.15-1.75,3.9-3.9,3.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 623.38,
    y: 640.12,
    width: 41.2,
    height: 25.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 637.89,
    y: 513.72,
    width: 12.19,
    height: 149.2,
    rx: 4.88,
    ry: 4.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M643.98,662.92h0c-2.15,0-3.9-1.75-3.9-3.9v-141.4c0-2.15,1.75-3.9,3.9-3.9h0c2.15,0,3.9,1.75,3.9,3.9v141.4c0,2.15-1.75,3.9-3.9,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M586.62,517.17h24.4v6.06c0,5.63-4.57,10.2-10.2,10.2h-4.01c-5.63,0-10.2-4.57-10.2-10.2v-6.06h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-180",
    cx: 598.82,
    cy: 517.17,
    rx: 12.2,
    ry: 8.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M609.31,515.52c0,3.8-4.69,6.87-10.48,6.87s-10.48-3.08-10.48-6.87,4.69-6.87,10.48-6.87,10.48,3.08,10.48,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1154.94,555.37c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M767.11,457.44v32.86h372.22c31.92,0,63.73,3.82,94.74,11.38l116.64,28.43c29.5,7.19,59.75,10.82,90.11,10.82h1645.73v-83.49H767.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 1298.46,
    y: 583.16,
    width: 97.35,
    height: 11.6,
    transform: "translate(-21.89 1125.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 1289.1,
    y: 510.52,
    width: 23.76,
    height: 163.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1266.14,683.19h69.68v3.54c0,2.51-2.04,4.55-4.55,4.55h-60.58c-2.51,0-4.55-2.04-4.55-4.55v-3.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1293.38,655.93l-15.72,27.23h46.63l-15.72-27.23c-3.38-5.85-11.82-5.85-15.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M1306.22,662.9c0,2.9-2.35,5.25-5.25,5.25s-5.25-2.35-5.25-5.25,2.35-5.25,5.25-5.25,5.25,2.35,5.25,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1292.53,494.97h16.9c7.16,0,12.98,5.82,12.98,12.98v130.64h-42.86v-130.64c0-7.16,5.82-12.98,12.98-12.98Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-88",
    cx: 1290.52,
    cy: 512.29,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1314.61,530.39c0,3.31-2.68,6-6,6s-6-2.68-6-6,2.68-6,6-6,6,2.68,6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M453.82,389.25v91.35h70.94v-91.35h-70.94ZM503.59,446.54c0,5.57-6.4,10.09-14.3,10.09s-14.3-4.52-14.3-10.09v-33.67c0-5.57,6.4-10.09,14.3-10.09s14.3,4.52,14.3,10.09v33.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M453.82,378.02v114.26h70.94v-114.26h-70.94ZM503.59,449.67c0,6.97-6.4,12.61-14.3,12.61s-14.3-5.65-14.3-12.61v-42.11c0-6.97,6.4-12.62,14.3-12.62s14.3,5.65,14.3,12.62v42.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M453.82,372.54v129.54h70.94v-129.54h-70.94ZM503.59,453.78c0,7.9-6.4,14.3-14.3,14.3s-14.3-6.4-14.3-14.3v-47.74c0-7.9,6.4-14.3,14.3-14.3s14.3,6.4,14.3,14.3v47.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M470.14,492.68c0,3.21-2.6,5.82-5.82,5.82s-5.82-2.6-5.82-5.82,2.6-5.82,5.82-5.82,5.82,2.6,5.82,5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M468.44,492.68c0,2.27-1.84,4.11-4.11,4.11s-4.11-1.84-4.11-4.11,1.84-4.11,4.11-4.11,4.11,1.84,4.11,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M520.07,492.68c0,3.21-2.6,5.82-5.82,5.82s-5.82-2.6-5.82-5.82,2.6-5.82,5.82-5.82,5.82,2.6,5.82,5.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-205",
    cx: 514.26,
    cy: 492.68,
    r: 4.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M3054.09,685.74c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-34.51-.81-46h-3.32v46.37c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 2554.57,
    y: 621.38,
    width: 88.38,
    height: 8.74,
    transform: "translate(276.18 -697.41) rotate(16.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M2778.88,579.05l-4.43-8.5c-2.04-3.9-6.85-5.42-10.76-3.38h0c-3.9,2.04-5.42,6.85-3.38,10.76l2.61,5h-86.63v-.37h-14.17v.37h-86.63l2.61-5c2.04-3.9.52-8.72-3.38-10.76h0c-3.9-2.04-8.72-.52-10.76,3.38l-4.43,8.5c-2.04,3.9-.52,8.72,3.38,10.75h0c3.52,1.84,7.76.77,10.06-2.32h20.08v2.28h7.89v2.28h12.5v2.28h13.82v2.28h17.77v2.28h17.08v1.49h14.17v-1.49h17.08v-2.28h17.77v-2.28h13.82v-2.28h12.5v-2.28h7.89v-2.28h20.08c2.3,3.09,6.54,4.16,10.06,2.32h0c3.9-2.04,5.42-6.85,3.38-10.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-186",
    cx: 2669.45,
    cy: 624.09,
    r: 39.87,
    transform: "translate(-35.63 1069.06) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M2669.2,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2669.2,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2761.5,626.8v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2669.2,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2669.2,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2669.2,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M2669.2,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2669.2,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M2669.2,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2669.2,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M2669.17,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2636.4,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2628.36,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2647.67,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM2669.04,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM2669.3,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2690.67,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2701.94,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM2709.98,634.27c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M2719.21,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2644.04,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2669.04,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2705.2,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M2634,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2669.04,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M2669.17,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2636.4,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2628.36,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2647.67,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM2669.04,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM2669.3,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2690.67,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2701.94,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM2709.98,634.27c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2671.68 645.21 2667.51 645.21 2665.42 648.82 2667.51 652.44 2671.68 652.44 2673.76 648.82 2671.68 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2671.64,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2685.89 637.27 2682.94 640.23 2684.02 644.25 2688.05 645.33 2691 642.38 2689.92 638.35 2685.89 637.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2688.41,639.86c.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2690.32 621.62 2690.32 625.79 2693.94 627.87 2697.55 625.79 2697.55 621.62 2693.94 619.53 2690.32 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2693.94,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2682.39 607.41 2685.34 610.36 2689.37 609.28 2690.45 605.25 2687.5 602.3 2683.47 603.38 2682.39 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2684.97,604.88c.8-.8,2.09-.8,2.89,0s.8,2.09,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2666.73 602.97 2670.9 602.97 2672.99 599.36 2670.9 595.74 2666.73 595.74 2664.64 599.36 2666.73 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2666.77,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2652.52 610.91 2655.47 607.96 2654.39 603.93 2650.36 602.85 2647.41 605.8 2648.49 609.83 2652.52 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2649.99,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0,.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2648.08 626.56 2648.08 622.39 2644.47 620.31 2640.86 622.39 2640.86 626.56 2644.47 628.65 2648.08 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2644.47,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2656.02 640.77 2653.07 637.82 2649.04 638.9 2647.96 642.93 2650.91 645.88 2654.94 644.8 2656.02 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2653.44,643.3c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.09-.8,2.89,0s.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 2669.2,
    cy: 624.09,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 2669.2,
    cy: 624.09,
    r: 13.18,
    transform: "translate(-71.98 629.95) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 2795.38,
    y: 621.38,
    width: 88.38,
    height: 8.74,
    transform: "translate(285.66 -764.31) rotate(16.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 2779.98,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 2793.86,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 2779.98,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 2793.86,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 3006.57,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 3020.45,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M3019.69,579.05l-4.43-8.5c-2.04-3.9-6.85-5.42-10.76-3.38h0c-3.9,2.04-5.42,6.85-3.38,10.76l2.61,5h-86.63v-.37h-14.17v.37h-86.63l2.61-5c2.04-3.9.52-8.72-3.38-10.76h0c-3.9-2.04-8.72-.52-10.76,3.38l-4.43,8.5c-2.04,3.9-.52,8.72,3.38,10.75h0c3.52,1.84,7.76.77,10.06-2.32h20.08v2.28h7.89v2.28h12.5v2.28h13.82v2.28h17.77v2.28h17.08v1.49h14.17v-1.49h17.08v-2.28h17.77v-2.28h13.82v-2.28h12.5v-2.28h7.89v-2.28h20.08c2.3,3.09,6.54,4.16,10.06,2.32h0c3.91-2.04,5.42-6.85,3.38-10.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-186",
    cx: 2910.26,
    cy: 624.09,
    r: 39.87,
    transform: "translate(-65.53 685.33) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M2910.01,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2910.01,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M3002.31,626.8v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.82.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2910.01,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2910.01,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2910.01,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M2910.01,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2910.01,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M2910.01,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2910.01,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2909.98,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2877.21,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2869.17,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2888.48,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM2909.85,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2910.11,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2931.48,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2942.75,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2950.79,634.27c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M2960.02,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2884.85,599.18c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2909.85,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2946.01,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M2874.81,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2909.85,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M2909.98,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2877.21,591.54c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2869.17,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2888.48,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM2909.85,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2910.11,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2931.48,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2942.75,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2950.79,634.27c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2912.49 645.21 2908.31 645.21 2906.23 648.82 2908.31 652.44 2912.49 652.44 2914.57 648.82 2912.49 645.21"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-181",
    cx: 2910.4,
    cy: 648.82,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2926.7 637.27 2923.75 640.23 2924.83 644.25 2928.86 645.33 2931.81 642.38 2930.73 638.35 2926.7 637.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2929.22,639.86c.8.8.8,2.09,0,2.89-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2931.13 621.62 2931.13 625.79 2934.74 627.87 2938.36 625.79 2938.36 621.62 2934.74 619.53 2931.13 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2934.74,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2923.2 607.41 2926.15 610.36 2930.18 609.28 2931.26 605.25 2928.31 602.3 2924.28 603.38 2923.2 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2925.78,604.88c.8-.8,2.1-.8,2.89,0,.8.8.8,2.09,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2907.54 602.97 2911.71 602.97 2913.8 599.36 2911.71 595.74 2907.54 595.74 2905.45 599.36 2907.54 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2907.58,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2893.33 610.91 2896.28 607.96 2895.2 603.93 2891.17 602.85 2888.22 605.8 2889.3 609.83 2893.33 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2890.8,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.09,0,2.89-.8.8-2.09.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2888.89 626.56 2888.89 622.39 2885.28 620.31 2881.67 622.39 2881.67 626.56 2885.28 628.65 2888.89 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2885.28,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2896.83 640.77 2893.88 637.82 2889.85 638.9 2888.77 642.93 2891.72 645.88 2895.75 644.8 2896.83 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2894.24,643.3c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 2910.01,
    cy: 624.09,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 2910.01,
    cy: 624.09,
    r: 13.18,
    transform: "translate(411.02 2240.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3015.42,580.58h-10.29l-16.86-36.19h43.48l-4.28,25.96c-.97,5.9-6.07,10.22-12.05,10.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2802.58 620.33 2777.26 620.33 2761.55 544.39 2815.88 544.39 2802.58 620.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-210",
    cx: 2789.1,
    cy: 567.74,
    r: 9.26,
    transform: "translate(-4.96 1110.56) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M2834.53,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M2999.26,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M3025.46,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M3019.22,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 2311.21,
    y: 621.38,
    width: 88.38,
    height: 8.74,
    transform: "translate(266.6 -629.79) rotate(16.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 2308.61,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 2322.49,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 2308.61,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 2322.49,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 2539.19,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2553.08,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 2539.19,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 2553.08,
    y: 462.55,
    width: 5.37,
    height: 79.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M2538.12,579.05l-4.43-8.5c-2.04-3.9-6.85-5.42-10.76-3.38h0c-3.9,2.04-5.42,6.85-3.38,10.76l2.61,5h-86.63v-.37h-14.17v.37h-86.63l2.61-5c2.04-3.9.52-8.72-3.38-10.76h0c-3.9-2.04-8.72-.52-10.76,3.38l-4.43,8.5c-2.03,3.9-.52,8.72,3.38,10.75h0c3.52,1.84,7.76.77,10.06-2.32h20.08v2.28h7.89v2.28h12.5v2.28h13.82v2.28h17.77v2.28h17.08v1.49h14.17v-1.49h17.08v-2.28h17.77v-2.28h13.82v-2.28h12.5v-2.28h7.89v-2.28h20.08c2.3,3.09,6.54,4.16,10.06,2.32h0c3.91-2.04,5.42-6.85,3.38-10.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-186",
    cx: 2428.7,
    cy: 624.09,
    r: 39.87,
    transform: "translate(-53.96 976.93) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M2428.45,533.19c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2428.45,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2520.75,626.8v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.86-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.59,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2428.45,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2428.45,541.72c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2428.45,671.18c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2428.45,566.61c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2428.45,673.97c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M2428.45,572c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2428.45,672.19c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2428.42,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2395.65,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2387.61,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2406.92,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM2428.29,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2428.55,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2449.92,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2461.19,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2469.23,634.27c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M2478.45,617.52c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2403.29,599.18c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2428.29,588.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM2464.45,602.44c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M2393.25,603.28c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2428.29,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M2428.42,573.6c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2395.65,591.54c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2387.61,634.53c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2406.92,660.34c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.97,3.45,11.09ZM2428.29,577.91c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2428.55,670.33c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2449.92,587.91c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2461.19,656.71c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2469.23,634.27c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2430.92 645.21 2426.75 645.21 2424.66 648.82 2426.75 652.44 2430.92 652.44 2433.01 648.82 2430.92 645.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2430.88,648.82c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2445.13 637.27 2442.18 640.23 2443.26 644.25 2447.29 645.33 2450.24 642.38 2449.16 638.35 2445.13 637.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2447.66,639.86c.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2449.57 621.62 2449.57 625.79 2453.18 627.87 2456.79 625.79 2456.79 621.62 2453.18 619.53 2449.57 621.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2453.18,621.66c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2441.63 607.41 2444.58 610.36 2448.61 609.28 2449.69 605.25 2446.74 602.3 2442.71 603.38 2441.63 607.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2444.22,604.88c.8-.8,2.1-.8,2.89,0,.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2425.97 602.97 2430.15 602.97 2432.23 599.36 2430.15 595.74 2425.97 595.74 2423.89 599.36 2425.97 602.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2426.01,599.36c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2411.76 610.91 2414.71 607.96 2413.63 603.93 2409.61 602.85 2406.66 605.8 2407.73 609.83 2411.76 610.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2409.24,608.32c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2407.33 626.56 2407.33 622.39 2403.72 620.31 2400.1 622.39 2400.1 626.56 2403.72 628.65 2407.33 626.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2403.72,626.53c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "2415.26 640.77 2412.31 637.82 2408.28 638.9 2407.2 642.93 2410.15 645.88 2414.18 644.8 2415.26 640.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M2412.68,643.3c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.1-.8,2.89,0,.8.8.8,2.09,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 2428.45,
    cy: 624.09,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 2428.45,
    cy: 624.09,
    r: 13.18,
    transform: "translate(-53.97 976.83) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2561.77 620.33 2536.45 620.33 2520.75 544.39 2575.08 544.39 2561.77 620.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-210",
    cx: 2548.29,
    cy: 567.74,
    r: 9.26,
    transform: "translate(1410.26 2917.42) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2293.1,544.39l5.86,62.92c.69,7.38,6.88,13.02,14.29,13.02h2.92l37.08-75.94h-60.14ZM2317.87,598.82c-5.11,0-9.26-4.15-9.26-9.26s4.15-9.26,9.26-9.26,9.26,4.15,9.26,9.26-4.15,9.26-9.26,9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M2352.97,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M2517.7,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M2543.9,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M2537.66,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M2593.72,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M2758.45,531.79c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M2784.65,624.09h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M2778.41,624.09h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M3055.65,502.25h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M3090.83,527.94h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.71v-7.36c0-3.16,2.56-5.71,5.72-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 3091.47,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3091.58,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 3089.76,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3090.22,529.66h.14c.19,0,.35.16.35.35v3.85c0,.19-.16.35-.35.35h-.14c-.19,0-.35-.16-.35-.35v-3.85c0-.19.16-.35.35-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 3088.05,
    y: 529.34,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3088.16,
    y: 529.66,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M3090.83,505.52h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.71v-7.36c0-3.16,2.56-5.71,5.72-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 3091.47,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 3091.58,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 3089.76,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M3090.22,507.24h.14c.19,0,.35.16.35.35v3.85c0,.19-.16.35-.35.35h-.14c-.19,0-.35-.16-.35-.35v-3.85c0-.19.16-.35.35-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 3088.05,
    y: 506.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 3088.16,
    y: 507.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 3063.71,
    y: 478.98,
    width: 15.99,
    height: 71.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 3071.7,
    y: 457.44,
    width: 15.99,
    height: 171.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 3071.7,
    y: 561.37,
    width: 15.99,
    height: 67.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M358.13,246.19c-3-8.99-13.79-25.78-34.17-28.78-20.38-3-206.85,2.4-218.24,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.24,0,4.05-1.81,4.05-4.05v-86.69c0-27.98-8.79-120.51-11.79-129.5ZM242.02,363.06c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM338.35,362.2c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.15,434.76c-124.03,0-234.59,18.08-306.44,46.31.03,2.13.08,4.2.15,6.24,71.85-28.19,182.35-46.25,306.3-46.25,11.04,0,21.96.15,32.77.43v-6.3c-10.81-.28-21.73-.43-32.77-.43Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 340,
    height: 81,
    transform: "translate(30.39 440.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVQAAABRCAYAAACNKF6yAAAACXBIWXMAAAsSAAALEgHS3X78AAAgAElEQVR4nO2dy84tu1GAy73+DOBhIkYgpqAgRqAgXgtITiSEFCFeACFeBpCAAYrIKFECidjn7L3aLgZ22VXl8q1X/9fdpb3/5bbLbvda7a/L5Us7uOSSSy45KIiIr10HkhBCHelc/HiB8zvnXuQ8l1xyyTOKhho/dM7BG2JeV6paLtR76RofgSyDZgXwC6iXXPJ2BKOcUhZv7Nu2yfOUE55yLi0rYAwhZMABLEDOyJOv2clSHimTy8xvcwH1kktOljPAiLEgq+whEHns5uaauFnSScDtloJYQNWp68xVBMS+3iJoh7+hUd8LqJdc0pAjYGyB8EieQHEWWKsIW2cWqMPyTaW166TrOdrVHlZHWbs562SZDth33qvKwbRLLvlwsgJJ7n+cAeVsV9rSC4hjcB4AK0Ld5Z+poyWUA63BH0sOwrwqZlLPBPYAsEd8r12V+dIuueRtyxGLUg8sjABmnreuyPFzGvlnuuM9HWcBdSSja5h9KK2e9wEIW799Li2Ve+YAnVXTC6iXvBs56pu08iAABO/bedqFjc/Hwwmej0Jxpk5Wuu7ya52htXmSlXm2WLXKFqq+5qPd+APX/ja/rUu+SlkFJu869/JV2EoRPoTjVqgh5jzIVL9hOR0ocp1hPZTOTHd/1tp8y/La08Oc+rzkkmeVFVjO+CsjBLAiUKvL3hpJ9h0r1SpHnr+vP928Z0B5RJfV5b3LCvSPDsSdIRdQLzlFZoG5NLiTgKnLXR6ooXJKXQFgEqZQnx8gWUTMIj2ErVU4qrxnWJYo/wyF5o2aXe7KQnf0b1GO5zvE0oMT8rlrge6lpwPlXPKVSggBtX/KkhE0s/1mqFSQmAImVN1+Ac9GlxuNieAannS9XV/oUVmA4pnWfUvXp2vs/8IOwLXnezbdHiJ/Dk3K8TxroBznGV3fZaFeUom2NhFKN4puKNeBEOVJiQY0bJiKfDo+hDiQNPBTzvooxw1/QhDhvu/gnINt24rlS2WXL+HxczWLO1Z2tKhqSi0Bq/4A78NieXY55+knrUX9EKzei31hzta45GuTUTfd7GrPDP7ofIOubQU3E46l227CsHWOTryud3W9E9ePyjJ2znVdCVVdToDj6Bz1bAYH2+YgBPIr12UcAYP9kFoB4Crgj5edHwCqzseAeGDp7CXvWw7BMyaI+IAhJ1JKsValrzLn4TetBbhOHHXZe5ZnL41bx9y6nvafigCKcopEC6g3DWtVumhtX7AZ27bGO83/WNLAbVCTcrjYdFGvpTvlihhEzcDyAuoHk+nBIW0FDkeyJSn1wBBa4UGaqKd2DYwGbBr+x9rKBLP7JiyTya457862Gk7d3Z+VtQxz/s5H5EDJDiD4II7bpc2AsE5sz5tt1Hctek6zU+YF1HcqM+AcPZVtuNUmJnV1OYQQA2xuG8IzpLmeS7jgeYG5DAaj0Vqnd/0tC9UqXVqe/Rb6iJXaurIQgjmf9BE/8HM1fB+C3QE2H0RtqJI7Ytu2B7vp51vhPY0LqG9clsBJXe/mRHLeJW+DEyFaAr0RaAISIsLttoE0LtEMU91GlqUERWuAgNc5/6ny18Ynivr3ZBVYfga8E+fcbgY8/UJdXqlV5zpWnGx13110ISXZti2l0QCoB53DlMPJ58P2AuobkaGPE6DeTccEZwFlaxBJd+Xz4IThA9XgsQDJRVqx/QcBdkAo6qunLDUGcmw92zfs93RdRgsIpjtgJFiNcGvRSSHg6Zbna0uEoB5Vl6uYto11jl0N4p6YFu58hsnk4wC/gPoKEhLBrDXHedchNdAD5YiUq7zVeShOdNftgSNKK3BtADHV0TlXNfwQQgVJ+yzizxRAehalAKmirgXXPZWlG6esh2FFT9aRW1k5b7LEXLbC6JyPDWQtu2qfWYJ6qGxuS3x14NW1Wt9TU5bVHodtrXLUEXDJqRIYpRybzzlef26TT1ueewUbG5pDa7MkFOhsW2MgIAEoGSMhhHRtbUho4LVAanXTLd0apG2I8nN7vwO3kGiOa1PMRNutEnwA8hhvbsvncFD7/makd48sAekFBAHBgUufAC9St1c5xSEnwiVHhQMUAKq5ii3RoBR+RbbiR1upvAtvwaE1bzMgVpB1zqnR9qqGskz+jh3EDNdB9nzQ9nd2XAn8GpMu6nAnjayo/P2qerXqHDCAWKSoWg9iBIoo+wwRP8fBcjvZxD1QEcFYltnQ2f0uFMb5GuXP1qNRJmmW/RsAbreblft0uYD6oFSrilqrhgiGg+lKvJvOdShsj5ojlGy89emR+Rqg27YtWYq5DgBAphcquJqWGNL1BWCEM4qX8WXU3OVus1WvUVz8XmJc9p9OCv+2W6Dc992MX5fjTVLn1F3s2fNN1yApmt9ng6Y6WviQRaLTh+20Tnr9AJp/QPR1DC13AXVZOEAx+RIBrDcgAmvIKa8sCLz3gBCd9GXWEllU8XOqoTJwarhzgLYAaRbZ0eVAReTXXftVcx7Sm+maszifR7dVunEJgfmJdbUR4ndR7UWAKoc+ZnF7chVYDX12oYCUYxN+jrgOnkN4/XbuRjHS64hjumMrtaM7Cfnb7dY9USvp977/fXdtjjIQAiiBinyF+ThZPkw/fYpCorVVWZcI++5zntvtBqgsWV6GFz5DZfFiKQ+KVn09IjCjU+vluYbJIiWQCcs1VzvU3fEqLIEWIR13DooPrY19H475TtHOb4Q58GamIJUewTwohaU22z9lsSvzhp9f5s62797gWQeWro59vXQku0ekhz1AE54NS9htb82j/QZEw9PaAER31et16ggYymi9sE8xwqg5+ZstieSj5RqyyIDkmQU7Y4GOdGbT0RhUK5O6XQGpKms6DtPDa3MVgAtI67gKpgi5J0AnGAG1mn5VXb0dtXtvtGdtxdvFTJyppJ3pn31GWbEmp/I+mn/OqTt57hLxh3/w+wbGv0LRAAWA+sVsUbEcK4DSAAmGwBpuLt8MW110tM5hgDQ7/g3g2Qx8JL0NW7LcdNOmubKmL1WdN35vqGKiBB/yYN5224bQbMV575kVG/9ayyPjOCLlYxXuHEfrOdopL73rPbI9Fcz0Y6WK4Mhivj/oNz4dPouboYrZK6O3par0H/zxHy30QT6oWAAV6VGphEGCkPvo7ndmGfbmhCZ41lZmw+pUn7ELPwe9HjBthh7Lmwc7FLy6A1zVyLyEoDhOcbvfAQMHaj4pOy+w30ymCcuU5fc+pK6eoGXbIu3oeO/zwIrZW3ghCZavfFWG0/iK7Pd7Cjnx0RKefOjho27C13hty/e+9z340z/5QfdKP7QPlQ8gBUTwwZcpFUXJhKff92hB0eiwYGQqU+2itLPlmPYnsLLYJ6uHGIRSBDoFikfT0kFv5JjPwQRxbRSFMpzSdJis04CBuVRmQAr5e4yWqc4bwyEky1JPEePXohZCyO+ixIUQomsCrPnA5wj53mUdmBxJYz8MQt8azS6wPKsjlXbAHGt6Vw+Uter60IsOymnr4XkrfgTTku+DCO0on1ccsRuf4jlIAcqNFlh3ne/O7r2vfzjVZc8NOYMSO2lFBwFgz5ZuC2596A3jVeaZeAzqevldYjxYrO52jp8AaAmn3yH9fogYlykugBQAwe9e6bF0ROB7HvD7YSbMoUlfS7WGf6FVWR1NH4qbQv/+Dy9LtckqQj1gEmi6sxpemCqD+QJCgvZni1xtwP/wz/9s6qreNVD5BHptafReWcHheU9dF4IDTWEqk74RPt/vpXG2rM0UWR78tiVKlm+pqDx4ybRqjp4BSzGiDmneoAFM730e6RxBU1uMOrx7Hwe1AuZBKQ3NVtyuLNN8W2igLsLUmr5GjWdomVo34Vxi50FXz7C05Nh0rlo4cJ4TptSD9GlPgOc0CYelp+S//IsfTp/l3XX5CaIBUY7GMmuErh6B+3py/vIk5pBEhC9KVwDQGGG34zhokkUzDb8+5JbAqdIzYgK2tM36ANDgkgRs3LoPy/VSmoJjPhcPi+QCR2mdJqDiNgVS/VtpoIq5w/wyBzD1zIfdApi954G42sW0RurBtKWdqibEnI8LMIDbqv7alLWxNKZRnSzvAqgZouSvovmPACAbLpvrmf6bI5GI8O3nz/nGFkkiKgZKQ41/rDAfCBnBDSwNI8NqGbzhmAgwD9s65eFjNGBXrjl/qq64qKMBUP7bedXVJ6DivstBqQZcTf81GnUUT5mJrn0Pfim9LLls67SjmyUbv+egwCMyWZRW82yK2JytvH7O9Wwnfi9J8n4Mk/JmgRpCECuSAMogAp/u8PnLl9gQvc9dOT7FYWdWy5cvd+BfOso/1fHeBGk8El0f02hoWxIrenxUvVZBHfFwej0Pcx6oLWjOwFQCNf7O27bF1VKdbjz3c9sgVS6ZfHrshuWUq/rL43Gry1lnxVzp1if0lD4GTO5eaa+tnON8fM3JMsDrApoyt1y3LW8GqNwKpc8IUDnfjgAKANUnb5j0nyDag2cLmgCQBjhihO46ua291LKcpJ1UfLn2XWre3FVwMq/R2ELQ7gizqOqIpkfpQSE+ENgDKOnzkkPa0JpASuF932G73cC0JrEs37WBKkFa/OKqUbLuvYy3v2MrrrsxSGemuOjWDjjRTj4GGAzYhFOrRAL8zdgEe6mgbvLk9ZxU9ll+ZoBXBmoIAREwriwS8xRL4/ju8+cc5p/ULdMA/fz5s7BC2sCsLU6e577vwjdGpr8YJWz8Dl75Tcfge+m0ErIeCD2YAsYHy7ZxHyokoOoX+LXgCvk39sHnlWVoAHXjL9RTgORTo3qWqQnbXI0EZeR1VOCtriHesy7OvQLnzvNTtkahrQdiM/FonkaUXtm33W5sj4VBHSaT+yrnl30mRLm8OFB9CEhd9vJCs3K5333+XDUcwAI46/+XL1+gtIdeoygtWsfR3p7UCUJE4KMXAUPtU2xBrEp+gfgWNBvxNICkpY6qC2hZqHzzkT5QY4BganX1c9zGBqWYlSrnCdtA7boBgI3c83qJD3ntQgfYzlmt36n9FbYiTy6DHTWLszPOAKfPsTnIv2TZzwVRLi8CVO89kn+NT1IGiABtWZ+7CdGo9+X+pYJjDsfAWhjSWy0hTiyngZCkBvrG7ENuBXxj3RWg6ji5/NNuXI0oMCqrUhkY0++yOTcJ0yDBKYAaB6VC6vLftlv+nYpFqcDJwvUxJBgnePNXvvQEtT+Z3zcxQHNey36bC6A8GYKHyliEKOnp/UXHnGw/IBZzLpX9EhDl8ixA9d6jeB+68oN++913oH1i1LUn+fLlDrnblhrH/X4fgjOnmXplFJ7rU5DPT5XJJ4DwpPxVo5nQtVb9qFIaYjfKuGlJtBxLXHK/0Kio5fNUYeE3VV19AqvbXAJ2zJX9nBymAA0LNVZep/F6d1ditcLZ57qXtIOQW4PgiWWkiCPAud1u3XxzrLTrOZmrKy8NUS6nAZVDVAP007fflgNE+L9Pn2KQ/aFw7L7HH3z3uwnGXJQJJbZShmI1YHydbsPv5aC3rKsGdSzd2j9aA7V/g7YBvIk6lOWikafqO1VAjdZpsUI5QPNyU7JU97KWn+4H7a6xIVo+afAt1xZRHLdBiiqfvDYaELvdtmqUfw2C9nfd+m0fLePR/VR9CHAzXi5oyTQvcVpzquzXgupDQC0Qle/80QD9zW9/m4BZwFn7NTGO4AfzVgT99e37ru6fNowsHdnISl1zfuY/fQ5ojvOr+nR0tWVtyypM7TwAbJd/Vj96R5ZL9V6GqQVURNjcBt57MXBUDSBVUK27/a20cvtpS7UfRxuhUJh3gZdBiFWObvqRc5wOGMx/1rKcXPZrWqOWLAP1vt/zlZJF+ulTAigi/Pp//hd0V12GIXWzoiVJo6S08UIsJpbrlWVhwbFOa4UhN+h+WfG42nh2Em6PwnGk22pswzXeo0Y7kYfykYUTZz4U3zgigpvs6gugGpZpPnY0yb79GxMgd7/DttEUq9p/ut/33MW/bZuEZg+o7BOgDGaJOMOvuArKZZAa4OFHzwWb2+3WmBs9D9i5+88+qGcYvB2ZAuqnT5/wvu/wu7/zO+m4APSXv/qVetovfEJ8uhM47W3aemFoNlq525Cha5UldFxbJ+ml1H7cAd25/PHPVPdt0PDsPP3GXLbqU0DNg1JQ/Ta0jaHlK62BGq3YHetVSGWJa3kaIZTpTxGwmB/cOQ6om46AyOe2jiFK4bKUWOoJv+LDIK1jZ0H6qhabfSHr2QyFRyfcv5Q0gfqrX/8ab9sG4FxevvlfP/uZgiJAuRn1Z0xD5D+yhFNeplnahdJZB6mAqtperwtXdexo1RVApVfFWeWdrCunOTV0LVGN76w8IYTKQg1Y3rElfxPIA0tT/wHl+UWXncouXf88GyQgRE6i0OGAzVO1bgZETbBCvsZqrwCV1h35RjN2GpStMhDqeaLPLcH7uNiiJc2bbHz3cY231p2fkQqo//3zn2NAhF/84pcAUACZwzFQ3YC+6paVdJpWE6Ms+PGG0tObC8sloRqc7DqySn081+U3yj+gW8fFPzrefAldTw4DeJyHLFQ+lxSRRv/lvdKHqQQe/09WaoFpur84ULPlmaZhWdDFeh7zrWGBtuKq/Rz4b9R7AI1AaisPy3hN2Nxutwzx7j01vOFqhfcIUS5PAAD//h//ibR07je/+W1O1D8vzdO0gBoPG7AD/YK6YpV2LcVOeRyCvDsHDZ2ZYwFl/sqDBei1dKvYZv46Vluna2A8kmcSwOn7o+4+YgCnYErholPDVAOVFg3su889BQlKqOJCWlRAMzxktz8K7WZVIM6+G8Pq5HFiUKzSiyP9Yhu/JVA2dNQP8FZg430wl54275fBjfRWrusMefqXf/03vLNt66r12A2LkkO1Z32Wl85hpaPjLEhaYb0pyYzFKY9TxlYZCKwhK1kA4aqu6Seq1CbQ+BBMV/JEPT7ItDmWG7l1CgxwNliL37vcU/t+z69BkWXIMC0UCIhxwIndUwRXvteD2BZwANbubmNUzzSl6/Z0WwZl9QBj6W8bNu27xEx5N9d1XJ7aADVA2YGh2Nne1CsNrRc3A1UAY2CiVBW6sJzRQQD/xRq1jX+s9mIBcj6uFFSN1otqrcL0uQFcAxVdB6YWSLnlCioN4/xWWvJbfKOQYbp7L1Zcxd2pvADqft/rc+87G+lP12KAlS8kqGBa5bW/1FWQvnXYtCf223dO66s5d7/TtyFPfMejNkBLWg+a+r3zPUj2YNmGav0jVHDMCdXtOpknXqtz+p1RxwDJg7385rSnqog1OE7lOQjgACG+3QDiQo7sR3X0+0bVEDDDr0ANADG+JXZzW4ZcNS8V48yAvIeCYZ0CSOt0v9P+qeVcAPZOZJDTCxw5POkFieUWZO2g/NA5XEDDvnnz63yfID0m5Qt4y9OdzpIn3/Bt9sCpLcy6W18aZsmTEjpxHJ60Y5PxnBeC+q7spFc+U5aVUjiwb7fbPDRzfF+33FRzoEMrsqMvg/MwXc1TNkhJFmoooHKbY78fgxYi61mkl/ptNUTFwJT35a2xCqYUDt5DSFOvaCEAByrdo7lcqmse6S8QpbqK6VEWRIv1Ud2DbZDmUt41RMsWfu2R/vd4XWfIU7U1GvTBOQPGYZwAboxj/M75+FZmNgsZBhCVTp2B3/jcIqygnNuNGut/AKQ8SPM3m2KCzjjvMM/zARWgM3rv5W+brVQB15h/w80sY9/3bLECsNVgDKaedGgea0DY8V72T0VobLBDboZbrgtdHCKA97sB0Qmwgvafyi+Obu2P2NUF+HohyuWJRl8BDJAacXQzSGC2whLIPD2IJaYxvO/G3pyckg2gWVZqy3LlxcVrb+dVA/11eQ1oWnBC1N36MRyNR0JXv9Z4Pmj7EMABhxQUC5SmogbZzS9QJXAxCzVI6AGQ5cvmtzKLs4CW+W/T66GL3zPqWN19Xm+6OArvbF2+ZYnaQG099GOOj9jdRXj5ObBvXZ50d71lYRb4jCBawqM0Dedt26bhWHWzOjqBz4Ptlatg6ByPG0OT4vlO+HYb64PxSB5b43kB7ECC1LGlwxRfLEoG0n3P7wdDZqFmXSzdfXoZ4+ZchikHa5kHGyDkvVVDGumPdWgBdd/jPUdXpa1TupZxOO3vm9iybbEr/FEtUS0Pv9r6A8lTnlsK5eaLYQDeirqglH/EsbYCtFVYA9c6j1X2Wj6xhZ1I75Xj5HEDpNb5xRsIKjFSujDt57FTnx/ADmJPAwHBgYsr0xLotOVaWZ/ZwqSloLVeHmwKAZCWtKYyd7/LTVbU4gJv7qdbn4Pqo18T3fK3U/xPvvmbd/0K9kueR56K9VbAN+oKa3BYaQKaMotc8cPOXXYEm4deX0dbp/I658u1z2MBlk/C79h7duqD+dp5j8C1juXfAfcuN7vTUIOMrFD+BtvKcrzv2eKMvtEALr+2uvx+LesUaaQfkluhVT9E2Pc7bNutsiZ/8s2PLmBesixP9/s9d7X1PqYAPG4EHg7OGEl+I8ux3wvLcufiLHBaeVZgypbzi3RAvk9AB39DYPVkkONQ2ROafV7nh+G2beVVMcryyzNHMlQNoKbuPJXBp0wBsKlQ6X1jAffSjU9gzXNUEcXntm3w5bN8mWMrDADw4x/91QXPS06RJ4SypLTfFZfAFGGWr13WTHgeptrqBagHfdZgaukofZSnNDdw7om2evvaEzJZQn4OHK+A3tUqBF+2ytNdaIyj9G7r+EeThQpkoYY6nYBafJRxSarfPZv7qqzTkN6UStO6FDwR8equX/Js8hQIgABDWCJvmB1d20/aKqOEQ4A4WXwAPjk9w4LgCKYzOig+pRvhuZ3wNenIEpzTnhfrWjZ6PXbXCi7WutWVDiFk67MFVK905IBUyN39MsfUZTDSGwL4HgEEVOcc3O/3rAtw+TwveRl5yntaHgCgF6PZLJ3dyNa0k945EPmmC5YlmhpU5YdVuR4GKgCAdCMQJOz3rLfbK6IB4IfcAeZZDkdry15Pk7WLKN1ry8L0IcCG8fcTlmtaKkqQBKTfnXyau5hXKj75qqogp0vl87KH7QXRS15anvjrgAGU9TkAKwB/K2QfqPY5DF2xiY2ev9fuktcQHedpp6UHhm/YZS1Ltm1ENs9vfCzna+XtvVOqfS4cllvpWF127wE2PWm/1Cu/oC/BNQ5OhZTuc1effKiICHvY8zSn1lQogAukl7yePOk5mi2IBhpgyoCE3A+ehqUKt8rQxxYY2pCs81t10GXFtLpc52bbJusCT+bQ+djHcr7+NC1ZsTNhCpCASp8ENufk4FQCKgIaA06xO08DU/TeKUrL4RAkSOkhhgjf/PivL4he8ury5AOf5iNh2LZezwwDgypA2OtXXliiBxt6OkZKhqjW0cfzQM0FpDMsZbI+lvN1fbv8gXaSTokqQCWAxvX1QQxM6QEpmmMaQgDctmzlBgZU7icFkNtBXgNMl7w1eQrV1CYVDtgEoHncSzO6ijP5WnE632ocxYu0ZEWRLAO1FEKhxaw11GZA2T3Pgk5Xr6FjAjUNOm3MMtVADSHkqU8be8DpASf6pPdBAV7d+kvepjgAgH/8p39G7swfQpP+6u6hshqnysGyUQkCwJYAtgTQCV25GUrfKuXH/L1JS4L5z1LeMro+OOds+TN6KFNXgXozrNB938H7kGdtUBed0gik8b+Pq5vEdCgUMKX/V9f+krcsTwDxFbh5knYSC5BVPAuvpAHwqVV0jhgOyiK0rc2Sr6dbVnFpYKr8yioVebZc+ZeF6hlAndZ5rKx66lMZeAJwOc77Xax+yiP9UDbZ0FsB0v9r8v0l70HiS/oQIaRPAAuM+Y+EYDdPHZbLVA1Yp7BzmWIsDQ7FWeecOSbI0tQgYMnLaMVSl25eBrcZmI51BnonwBRAA7WEAaC8OprdA9ZgE43yB2Op6GWVXvJe5AkARJf7XJAqa4uDwMqT0rdtAaDqPC3dWYA2jyv1Bagy1b4/dKLsRVA+BNNJ4BagQu7a1xZq8YdKqEZLFRyIgagLpJe8R4lATYMJABKkFVQBpqxYr/2AFkhbsEYAANuqZNkBwNokehWgLG50zPLJYLG8urICY5QHc5boVMkPlV1FJdm9z6uYuO+zXgkFEqjqPyTdC6SXvFd5AoD0PnNog1RBdbhcdbasRjiE0p44QGNarwuvy2M6E8AcQjiJXpapclX6lRgqfRtwlH/BXu7lNdKaScAeIggAt60CavCBzNdsvQrrFKU74ILpJe9dUpcfYQmQR/JYYdaSeVj7UPtQLfHHodkvYw8etk2282AtJ52RDvlmLFd6b9KcW2BQ6qQFCmhsPKPS485c3BJNo/peTsAPBNFQIAtwwfSSjyGpy9/ropdwNaVn0fKcDTun15a33i3VAWMKWjZWX9eOk69sMbPLiI7urL7eTpEwFiCk6VwyfnTOWV1z8KwHaQFUZoliGnAClzd7trbbu0B6yUeRYZd/3hJNxzNhlh+gBiotA6UBjSItWIKtZwG1AVm6zpaVK+bHWvVpRPNzYeAlt4HVHwyLfzVUm3mb1WQPSbM65kXUqRRode3ZKH5eFcXcAhdML/lIkm/mn/79P8SXKKUGgcDJMwCnTsvHEpg9P6ccbEovZav07Lz00YZnxzpl+fKDxQCruWKqAU5TUrSwttuFpMN2muMuiAVLNOjNZow6zpzfStu26IqwJu875/I6fNoU5YLpJR9NniiAAADZgkLGGwXWCavTBmo7v70V31kwteLKcdlCrqGXLVRRUqlvy+ocwdawOq20VrqztgtU+cROYA0dkT4C80TeeL+gWKfPLdRrStQlH1kKUJEoIi3OQ3AdWLZxdDefOANDgtLYaBp1m9Zxc4C1LVF9LNOqvZzYofXqmBFEZ3VKlNTBtLWgcy5ZhcfKqXX66T0dvplOYKudAOJL9QCv141c8rGlADUPuqAAmVx2egCoSGWgAVEeljA7G6bSEo3nLbT8hb8AAAGhSURBVBo1SHVagOhHnbM25blVrZt5e+mWq2BLGy5X+RZB2corz1n9AKXM9BFXlJX5pgRU2tTkmx9dVuklH1ukhRpDDTjOw5VGxMdl9iCLzG85hmexOlVZOm8TpOO0YPf7uxCdA6xMr0f31cWmuAB7NTDVA+s0dA2oWnXIeRj0t03uqk/5L5he8jWIuMn/9u9+igCykehwtmTZe4RNH6hphU5Alum69NrRvmUKGYSWFfowWFm4HumfgKQJLplXr7Jqw0vGuwbge2VY5yex3r4g8zXqxB60BFSf9kO9Nja55GuSJ37AJ1mTUCNz/AVpja3w7PAYsiZw44TUIUzLtB+Biap8nZaPe2nqfKELqKLfSs/7DQxAadXH1A00sm6f29qjoSrLjG9cx0QZeru9C6aXfE0yBCod642YOfj6lmgjvALXeJSZgaIbWudfScvHE2nkRxV6DZD1gbgYP6Hbyt+zOpdBO6lLehdML/naRAKVdueHGcvzHGhOW6qNMgHOAWsPpPw4aBfEBNQehWUvnt7bpKVZ9pKl2oif0L1gesnXKP8PIZyI66vzqDAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "168.54 521.19 36.87 521.19 36.87 594.03 69.75 594.03 69.75 633.1 77.54 633.1 77.54 594.03 119.51 594.03 119.51 633.1 127.3 633.1 127.3 594.03 138.96 594.03 168.54 521.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "136.02 568.75 69.75 568.75 69.75 528.58 154.28 528.58 136.02 568.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 67.8,
    y: 626.53,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M123.79,208.5h219.58v24.37H99.63v-.21c0-13.34,10.83-24.16,24.16-24.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M360.3,206.55V50.36s-216.57,125.18-239.8,148.15c-23.23,22.97-20.79,32.45-20.79,32.45l260.59-24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M360.3,216.88v-72.11s-216.57,51.79-239.8,66.84c-23.23,15.04-20.79,21.26-20.79,21.26l260.59-15.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M128.48,564.15h-46.45c-4.11,0-7.45-3.34-7.45-7.45v-28.12h74.86l-14.19,31.21c-1.21,2.66-3.86,4.37-6.78,4.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 67.8,
    y: 623.24,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M65.35,633.1H31.17c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 765.14,
    width: 2328.31,
    height: 484.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 772.04,
    y: 6,
    width: 2314.51,
    height: 472.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "776.37 8.79 3086.55 8.79 3086.55 6 772.04 6 772.04 478.98 776.37 478.98 776.37 8.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M358.13,246.19c-1.84-5.52-6.63-13.96-14.75-20.36v-7.91l16.92-1.04V50.36s-216.57,125.18-239.8,148.15c-23.23,22.97-20.79,32.45-20.79,32.45h.01c-.02.26-.03.53-.04.8-.04.3-.05.53-.04.71,0,.07,0,.13,0,.2v.21h.45c-19.11,34.37-68.71,171.94-68.71,198.37,0,38.17-2.8,68.16,2.8,89.95h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.23,0,4.05-1.81,4.05-4.05v-86.68c0-27.98-8.79-120.51-11.79-129.5ZM242.02,363.06c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.58c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM338.35,362.2c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M241.73,435.65h-22.7c-4.52,0-8.19-3.67-8.19-8.19h0c0-4.52,3.67-8.19,8.19-8.19h22.7c4.52,0,8.19,3.67,8.19,8.19h0c0,4.52-3.67,8.19-8.19,8.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 215.55,
    y: 423.89,
    width: 28.17,
    height: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M216.45,431.03h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57h7.62v7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M242.83,423.89h7.62c1.97,0,3.57,1.6,3.57,3.57h0c0,1.97-1.6,3.57-3.57,3.57h-7.62v-7.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 216.97,
    y: 424.9,
    width: 25.34,
    height: 5.14,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 76.19,
    y: 502.95,
    width: 20.71,
    height: 12.88,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 77.32,
    y: 503.89,
    width: 18.45,
    height: 11,
    rx: 2.33,
    ry: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 92.89,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.08,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 89.92,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.11,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 86.94,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.14,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 83.97,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.16,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 81,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.19,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 78.03,
    y: 504.93,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.22,
    y: 505.11,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M18.53,393.26c-.4.12-.83.17-1.27.14-1.82-.12-3.08-1.54-2.83-3.19,2.09-13.66-6.85-24.06-6.94-24.16-1.09-1.25-.8-3.13.67-4.21,1.46-1.08,3.54-.94,4.64.31.44.49,10.68,12.3,8.21,28.48-.19,1.25-1.2,2.26-2.47,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M9.49,363.1c-.43-.49-1.03-.76-1.67-.9-1.12,1.1-1.32,2.71-.33,3.84.09.1,3.87,7.76,6.94,24.16.28,1.48.82,2.75,2.37,3.07.47-.46.8-1.05.9-1.7,2.47-16.18-7.77-27.99-8.21-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M130,253.18h-4.65c-.96,0-1.78.58-2.17,1.4H25.75c-13.21,0-23.95,10.75-23.95,23.95v96.79c0,9.82,5.89,18.54,15,22.21l65.88,26.56c.03,1.3,1.08,2.35,2.39,2.35h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-4.65c-.44,0-.82.15-1.18.35l-66.2-26.69c-5.23-2.11-9.27-6.08-11.51-10.97l7.92-3.19c.63-.25.94-.97.68-1.61-.25-.63-.97-.94-1.61-.68l-7.89,3.18c-.69-2.13-1.09-4.39-1.09-6.72v-62.87h12.78c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2H4.19v-31.52c0-11.89,9.67-21.55,21.55-21.55h97.71c.44.59,1.1,1,1.9,1h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-193",
    cx: 17.58,
    cy: 310.34,
    rx: 6.1,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M18.35,267.81h.98v85.07h-.98c-4.61,0-8.34-3.74-8.34-8.34v-68.38c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M10,276.08h.1c1.8,0,3.25,1.46,3.25,3.25v62.02c0,1.8-1.46,3.25-3.25,3.25h-.1v-68.53h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 2933.47,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(5898.26 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2934.85,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(5883.57 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2935.38,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5872.39 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2935.78,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5872.65 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2937.62,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5876.87 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2938.02,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5877.12 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2939.85,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5881.34 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2940.25,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5881.59 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2942.09,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5885.81 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2942.49,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5886.07 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2944.33,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5890.28 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2944.73,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5890.54 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2946.56,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5894.75 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2946.96,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5895.01 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 2949.54,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(5912.96 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2950.07,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5901.78 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2950.47,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5902.03 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M2952.77,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(5906.25 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2952.71,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5906.5 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2954.54,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5910.72 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2954.94,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5910.97 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2956.78,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5915.19 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2957.18,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5915.45 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M2959.48,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(5919.66 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2959.42,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5919.92 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2961.25,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(5924.13 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2961.65,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(5924.39 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 2219.37,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(4470.07 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 2220.75,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(4455.38 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2221.28,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4444.2 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2221.68,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4444.45 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2223.52,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4448.67 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2223.92,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4448.92 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2225.76,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4453.14 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2226.15,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4453.4 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2227.99,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4457.61 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2228.39,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4457.87 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M2230.69,489.76h.71c.25,0,.46.21.46.46v8.68c0,.25-.21.46-.46.46h-.71c-.25,0-.46-.21-.46-.46v-8.68c0-.25.21-.46.46-.46Z",
    transform: "translate(4462.08 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2230.63,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4462.34 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2232.46,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4466.56 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 2232.86,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4466.81 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 2235.44,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(4484.76 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2235.97,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4473.58 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2236.37,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4473.83 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2238.21,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4478.05 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2238.61,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4478.31 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2240.45,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4482.52 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2240.85,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4482.78 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2242.68,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4486.99 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2243.08,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4487.25 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2244.92,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4491.47 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2245.32,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4491.72 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 2247.15,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(4495.94 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2247.55,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(4496.19 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 1505.27,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(3041.87 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1506.65,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(3027.18 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 1507.18,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3016 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1507.58,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3016.25 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 1509.42,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3020.47 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1509.82,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3020.73 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 1511.66,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3024.94 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1512.06,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3025.2 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 1513.89,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3029.41 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1514.29,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3029.67 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 1516.13,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3033.89 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1516.53,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3034.14 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 1518.36,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3038.36 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1518.76,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3038.61 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 1521.34,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(3056.56 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1521.88,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3045.38 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1522.27,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3045.64 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1524.11,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3049.85 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1524.51,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3050.11 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1526.35,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3054.32 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1526.75,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3054.58 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1528.58,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3058.8 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1528.98,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3059.05 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1530.82,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3063.27 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1531.22,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3063.52 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1533.05,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(3067.74 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1533.45,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(3068 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 791.17,
    y: 487.03,
    width: 31.33,
    height: 15.05,
    rx: 2.11,
    ry: 2.11,
    transform: "translate(1613.67 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 792.55,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(1598.98 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 793.09,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1587.8 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 793.49,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1588.06 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 795.32,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1592.27 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 795.72,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1592.53 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 797.56,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1596.75 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 797.96,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1597 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 799.79,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1601.22 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 800.19,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1601.47 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 802.03,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1605.69 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 802.43,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1605.94 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 804.27,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1610.16 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 804.66,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1610.42 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 807.24,
    y: 488.62,
    width: 13.88,
    height: 11.87,
    rx: 2.1,
    ry: 2.1,
    transform: "translate(1628.36 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 807.78,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1617.18 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 808.18,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1617.44 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 810.01,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1621.66 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 810.41,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1621.91 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 812.25,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1626.13 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 812.65,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1626.38 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 814.48,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1630.6 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 814.88,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1630.85 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 816.72,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1635.07 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 817.12,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1635.33 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 818.96,
    y: 489.76,
    width: 1.63,
    height: 9.61,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(1639.54 989.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 819.36,
    y: 489.94,
    width: 1.09,
    height: 2.73,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(1639.8 982.62) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M383.6,535.42c0-25.52-20.69-46.21-46.21-46.21h-104.53c-30.03,0-57.31,17.48-69.85,44.76l-27.85,60.56h7.1c8.07,0,15.4-4.7,18.77-12.03l18.77-40.81c9.53-20.72,30.25-34,53.05-34h104.54c15.31,0,27.73,12.41,27.73,27.73v45.06c0,7.76,6.29,14.06,14.06,14.06h4.43v-59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M359.1,249.49H119.55c-8.54,0-16.2,5.07-19.52,12.93-10.67,25.25-35.48,90.47-35.48,150.45v108.32h2.4v-108.32c0-59.55,24.68-124.4,35.29-149.52,2.94-6.96,9.73-11.46,17.31-11.46h135.21c2.15.72,3.72,2.73,3.72,5.12v217.13c0,9.58-7.79,17.37-17.37,17.37h-5.71v1.8h5.71c10.57,0,19.17-8.6,19.17-19.17v-217.13c0-2-.82-3.81-2.14-5.12h100.96c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M388.31,533.18c0-26.49-21.47-47.96-47.96-47.96h-108.5c-31.17,0-59.48,18.14-72.5,46.46l-28.9,62.86h7.37c8.38,0,15.98-4.88,19.48-12.49l19.48-42.36c9.89-21.51,31.39-35.29,55.07-35.29h108.5c15.89,0,28.78,12.88,28.78,28.78v46.76c0,8.06,6.53,14.59,14.59,14.59h4.6v-61.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M30.75,473.62h0c-.26,18.74.1,34.62,3.43,47.56h8.89v-35.24c0-6.8-5.52-12.32-12.32-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M44.27,485.94c0-7.45-6.06-13.52-13.52-13.52-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2c6.13,0,11.12,4.99,11.12,11.12v35.24h2.4v-35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M41.57,434.27c0-21.13,28.84-110.02,51.01-167.03,1.36-3.5-1.23-7.26-4.99-7.26h-.22c-22.55,52.9-55.99,149.56-55.99,171.26,0,2.71-.02,5.37-.04,8.01h5.3c2.72,0,4.94-2.2,4.94-4.93v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M94.38,418.55c-4.24,0-8.36-1.43-11.78-4.18-4.74-3.81-7.33-9.49-7.08-15.57,1.61-40.29,11.3-79.94,31.43-128.55,3.15-7.61,9.39-11.47,18.56-11.47h107.92c4.53,0,9.79,5.06,9.79,11.59v92.69c0,9.98-6.74,18.73-16.39,21.27l-127.56,33.58c-1.62.43-3.26.64-4.88.64ZM125.5,261.18c-8.21,0-13.56,3.27-16.34,9.99-20.01,48.34-29.65,87.73-31.25,127.73-.21,5.32,2.04,10.28,6.19,13.61,4.13,3.31,9.43,4.44,14.55,3.09l127.56-33.58c8.6-2.26,14.61-10.06,14.61-18.95v-92.69c0-4.95-4.07-9.19-7.39-9.19h-107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M327.26,374.49h-41.37c-6.78,0-12.29-5.51-12.29-12.29v-91.13c0-6.78,5.51-12.29,12.29-12.29h41.37c6.78,0,12.29,5.51,12.29,12.29v91.13c0,6.78-5.51,12.29-12.29,12.29ZM285.89,261.18c-5.45,0-9.89,4.44-9.89,9.89v91.13c0,5.45,4.44,9.89,9.89,9.89h41.37c5.45,0,9.89-4.44,9.89-9.89v-91.13c0-5.45-4.44-9.89-9.89-9.89h-41.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M36.63,440.45h-5.3c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2h5.3c2.06,0,3.74-1.67,3.74-3.73,0-22.09,30.26-113.96,51.09-167.51.5-1.29.34-2.68-.44-3.82-.79-1.15-2.04-1.81-3.43-1.81-.66,0-1.31-.54-1.31-1.2s.42-1.2,1.09-1.2c2.39,0,4.41,1.07,5.63,2.85,1.22,1.78,1.48,4.04.69,6.05-23.55,60.54-50.92,146.5-50.92,166.59,0,3.43-2.75,6.18-6.14,6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1523.35,666.29h0c-1.99,0-3.61-1.61-3.61-3.61v-53.66c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v53.66c0,1.99-1.62,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1817.21,666.29h0c-1.99,0-3.61-1.61-3.61-3.61v-53.66c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v53.66c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M2111.06,666.29h0c-1.99,0-3.61-1.61-3.61-3.61v-53.66c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v53.66c0,1.99-1.62,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1670.28,662.69h0c-1.99,0-3.61-1.61-3.61-3.61v-160.5c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v160.5c0,1.99-1.62,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1964.14,662.69h0c-1.99,0-3.61-1.61-3.61-3.61v-160.5c0-1.99,1.61-3.61,3.61-3.61h0c1.99,0,3.61,1.61,3.61,3.61v160.5c0,1.99-1.61,3.61-3.61,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1376.41,612.6h881.59c1.99,0,3.6-1.61,3.6-3.6s-1.61-3.6-3.6-3.6h-881.59c-1.99,0-3.6,1.61-3.6,3.6s1.61,3.6,3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1376.41,558.92h881.59c1.99,0,3.6-1.61,3.6-3.6s-1.61-3.6-3.6-3.6h-881.59c-1.99,0-3.6,1.61-3.6,3.6s1.61,3.6,3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1400.13,666.29h834.16c15.06,0,27.31-12.25,27.31-27.31v-140.41c0-1.99-1.61-3.6-3.6-3.6s-3.6,1.61-3.6,3.6v140.41c0,11.09-9.02,20.11-20.11,20.11h-834.16c-11.09,0-20.11-9.02-20.11-20.11v-140.41c0-1.99-1.61-3.6-3.6-3.6s-3.6,1.61-3.6,3.6v140.41c0,15.06,12.25,27.31,27.31,27.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M1486.84,612.6h32.91v46.49h-32.91v7.2h73.42v-7.2h-33.29v-46.49h33.29v-7.19h-73.42v7.19ZM1372.82,638.98c0,15.06,12.25,27.31,27.31,27.31h13.3v-7.2h-13.3c-11.09,0-20.11-9.02-20.11-20.11v-26.38h33.41v-7.19h-40.61v33.57ZM2220.99,605.41v7.19h33.41v26.38c0,11.09-9.02,20.11-20.11,20.11h-13.3v7.2h13.3c15.06,0,27.31-12.25,27.31-27.31v-33.57h-40.61ZM1780.5,612.6h33.1v46.49h-33.1v7.2h73.42v-7.2h-33.1v-46.49h33.1v-7.19h-73.42v7.19ZM1633.67,612.6h33v46.48s0,0,0,0h-33v7.2h73.42v-7.2h-33.2s0,0,0,0v-46.48h33.2v-7.19h-73.42v7.19ZM2074.16,612.6h33.29v46.49h-33.29v7.2h73.42v-7.2h-32.91v-46.49h32.91v-7.19h-73.42v7.19ZM1927.33,612.6h33.2v46.48s0,0,0,0h-33.2v7.2h73.42v-7.2h-33s0,0,0,0v-46.48h33v-7.19h-73.42v7.19Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6AxTandemTridem);
export default __webpack_public_path__ + "static/media/6-Ax Tandem-Tridem.ffb32b5082d9b97b056c2b260990198e.svg";
export { ForwardRef as ReactComponent };